import { a } from 'aws-amplify'

const cabinetOrigin = process.env.VUE_APP_CABINET_ORIGIN.toUpperCase()

export default {
	//login home page
	loginHeader: {
		contactUs: 'お問い合わせ',
	},
	loginPage: {
		instructionstitle1: '時間と手間なく全てが',
		instructionstitle2: '叶うプラットフォーム',
		instructionstitle3: '',
		options1f: '会員ページ',
		options1l: '',
		options2f: 'IBポータル',
		options2l: '',
		options3f: 'Propレポート',
		options3l: '',
		termsAndConditions: '利用規約',
		privacyPolicy: 'プライバシーポリシー／個人情報管理方針',
		amlPolicy: 'AMLポリシー／マネーロンダリング対策方針',
		refundPolicy: '返金ポリシー／返金方針',
		riskDisclosure: 'リスク開示',
		complaintsProcedure: '苦情処理手順',
		cookiePolicy: 'クッキーポリシー',
		userError: 'パスワードを間違えています。再度ご入力してください。',
		userErrorTwo:
			'入力したメールアドレスは登録されていません。確認してもう一度お試しください。',
		enterCodeBelow:
			'下記のボックスに、ご利用の認証アプリケーションから送信されたコードをご記入ください',
		enterYourCode: '２段階認証コードを入力してください',
		authCode: '認証コード',
		loginMobile: 'ログイン',
		loginOr: 'メールアドレスでログイン：',
	},

	wellcomeComponent: {
		title: 'アカウント登録頂きありがとうございます。',
		titlesub: 'これより口座申請へとお進みください。',
		subTitle: 'アカウント設定と本人確認を開始します。',
		before: '事前に以下の書類をご用意ください。',
		government:
			'• 写真付き本人確認書類一点（パスポート・免許証・マイナンバーカード等）',
		proof:
			'• 現住所確認書類一点 （住民票・クレジットカード、公共料金の請求書などー3か月以内に発行された書類のみ有効）',
		signature: '** 電子署名も後ほどご提出いただく必要があります。',
		agree:
			'*  Tradeview Financial Markets S.A.C. が本人確認書類を含む個人情報に対し電子的な本人確認を行うことに同意します。この情報は、信頼できる本人確認サービスプロバイダーと共有され、その正確性を確認し、同社が保有するデータまたは他の信頼できる情報源から取得したデータと照合されます。',
		agreeLATAM:
			'*私はTradeview Financial Markets S.A.C. が本人確認書類を含む個人情報に対し電子的な本人確認を行うことに同意します。その際、情報はその正確性を確認するために信頼性の高い本人確認サービスプロバイダーと共有され、同社のデータや他の信頼性の高い情報源から取得したデータと照合されるのを承認します。',
		btnContinue: '次へ',
		btnGoBack: '戻る',
		btnConfirm: '決定',
		checkError: 'チェックを入れ同意する',
	},

	loginBox: {
		title: 'ログイン',
		logInGoogle: 'グーグルでログイン',
		logInFacebook: 'フェイスブックでログイン',
		or: 'メールアドレスでログイン：',
		email: 'メールアドレス',
		placeholderEmail: 'メールアドレスを入力してください',
		placeholderPassword: 'パスワードを入力してください。',
		password: 'パスワードを入力してください。',
		submit: '次へ',
		forgot: 'パスワードをお忘れですか',
		doNotAccount: '',
		signUp: '新規アカウント登録',
		tryFreeDemo: 'デモ口座を開設する',
		remember: 'ログイン情報を保存する',
		emailError: 'メールアドレスをご記入ください',
		passwordError: 'パスワードを入力してください',
		passwordToEmail: 'メールをご確認ください',
		passwordToEmailDesc:
			'アカウントをリセットするための一時的なパスワードを送信しました。',
	},

	forgotPage: {
		instructionstitle1: '世界最高基準の',
		instructionstitle2: 'トレード環境と',
		instructionstitle3: 'テクノロジー',
		options1f: '会員ページ',
		options1l: '',
		options2f: 'IBポータル',
		options2l: '',
		options3f: 'Propレポート',
		options3l: '',
	},

	forgotBox: {
		title: 'パスワード再設定',
		email: 'メールアドレス',
		text1: 'ご登録メールアドレスをご入力してください',
		text2: '',
		placeholderEmail: 'メールアドレスを入力してください',
		badFormatEmail: `入力したメールが有効な形式であることを確認してください。例えばユーザー名@mail.com`,
		badEmail: 'ご登録のメールアドレスを入力してください',
		wrongEmail: 'メールアドレスをご確認後再度ご入力してください',
		continue: '次へ',
		limitExceeded: '限度超過',
		requiredField: 'このフィールドは必須です',
		goBackLogIn: 'ログインに戻る',
	},

	verifiCode: {
		title: 'メールアドレスの認証',
		text1: 'ご登録いただきましたメールアドレスにコードを送信しました。',
		text2:
			'こちらにコードを入力してください。受信箱にメールが届いていない場合は「迷惑メールフォルダ」もご確認ください。',
		label1: '認証コード',
		label2: '6桁のコードを入力してください　例: 123456',
		label3: '入力されたコードが無効です。もう一度お試しください。',
		submit: '送信',
		text3: 'コードを再送する',
		text4: '別のコードを受け取る',
		alert1: 'コードを送信しました：',
		alert2: '現在コードを送信できません。後ほど再度お試しください。',
		alert3: '確認コードが正しくありません。もう一度やり直してください。',
		error: 'エラーが発生しました。 {contactInfo} へご連絡をお願いいたします。',
	},

	setPassword: {
		title: '新しいパスワードを設定してください',
		text1: '新しいパスワードを入力してください。 ',
		text2: '以前に使用されていたパスワードとは異なります。',
		label1: '新しいパスワード',
		label2:
			'パスワードは8文字以上で、少なくとも1つの小文字、1つの大文字、1つの数字、および1つの特殊文字を含める必要があります',
		label3: 'パスワードの確認',
		placeholder1: '新しいパスワードを入力してください',
		placeholder2: '新しいパスワードを確認してください',
		error1:
			'パスワードは8文字以上で、少なくとも1つの小文字、1つの大文字、1つの数字、および1つの特殊文字を含める必要があります',
		error2: 'パスワードが一致しません。ご確認後再度お試しください。',
		description:
			'登録されたメールアドレスにアクティベーションコードを送信しました。受信トレイを確認し、以下に入力してください。アクティベーションコードを確認した後、新しいパスワードを入力してください。以前使用したパスワードとは異なるものを設定してください。',
	},

	setPasswordSuccess: {
		title1: 'パスワードが',
		title2: 'リセットされました!',
		login: 'ログイン',
	},

	consoleHeader: {
		account: 'アカウント#',
		balance: '残高',
		equity: '有効証拠金',
		free: '余剰証拠金',
		margin: '証拠金維持率',
		status: 'ステータス',
		hello: 'こんにちは',
		logout: 'ログアウト',
		confirm: '決定',
		outModal: 'ログアウトしてもよろしいですか?',
		yes: 'はい',
		not: 'いいえ',
		settings: '設定',
		areYouDone: 'ログアウトをしてもよろしいですか',
		areYouSure:
			'ログアウトをご希望ですか？保存されていない情報は削除されますのでご注意ください',
		yesLogOut: 'ログアウトする',
	},

	// Platforms page
	platforms: {
		description:
			'トレードビューでは、デスクトップ、スマホでのトレード等、ライフスタイルに合わせたディバイスにてプラットフォームをご利用いただけます。ご希望のソフト・アプリをお選びいただきダウンロードください。',
		mainTitle: 'ダウンロードセンター',
		metatrader4: {
			desc1: '使いやすくカスタマイズ可能なインターフェース',
			desc2: '効率的な取引のための迅速な実行速度',
			desc3: '簡単な注文',
			desc4: '効果的なポジション管理',
			desc5: '情報に基づいた意思決定のための価格変動の可視化',
		},
		metatrader5: {
			desc1: 'デバイスで利用可能な主要な取引ツールと口座情報',
			desc2: '市場の重要なイベントを逃さないためのアラート',
			desc3: '自動取引のサポート',
			desc4: '80以上のインジケーターと分析ツール',
			desc5: '高度な取引戦略のための先進ツール',
		},
		cTrader: {
			desc1: '迅速で使いやすいインターフェース',
			desc2: '通貨市場へのダイレクトなアクセス',
			desc3: '簡単な注文設定',
			desc4: '多様な情報ツール',
			desc5: '取引を有利にする先進テクノロジー',
		},
		sterling: {
			desc1: 'カスタマイズ可能なレイアウトとショートカットキー',
			desc2: 'レベルIおよびレベルIIのリアルタイム市場情報',
			desc3: 'ポジションおよび利益/損失のリアルタイムモニタリング',
			desc4:
				'1シンボルあたり60以上のデータポイントをフィーチャーした調整可能なティッカーウォッチリスト',
			desc5: '90以上のインディケーターパッケージ',
		},
		lightspeed: {
			desc1: 'さまざまな価格の複数のロケートソース',
			desc2: '事前設定された設定に基づいてカスタマイズ可能な注文',
			desc3: '複雑な戦略のためのオプション注文フォーム',
			desc4:
				'迅速な注文入力のためのカスタマイズ可能なウォッチリストとホットキー',
			desc5: '包括的なリスク管理設定',
		},

		takion: {
			desc1: '複数のチャートタイプ、時間枠、およびテクニカル指標。',
			desc2: '効率性を高める市場アクセスによる直接取引',
			desc3: 'リアルタイムの市場スキャナーとニュース更新',
			desc4: 'レベル II のリアルタイムおよび販売データ。',
			desc5: 'シームレスな取引操作のためのレイヤーとワークスペース',
		},

		das: {
			desc1: '高度な注文タイプとリアルタイムのチャート作成',
			desc2: '複数アカウントの管理',
			desc3: '迅速な注文入力のためのカスタマイズ可能なホットキー',
			desc4: '米国の主要取引所への低レイテンシーの注文検証',
			desc5: 'リアルタイムの市場データへのアクセス',
		},

		api: {
			desc1: '当社の取引サーバーへの直接かつ高速な接続',
			desc2: '高速実行とプラットフォームのカスタマイズ',
			desc3: '送信および受信されたデータの完全な制御',
			desc4: 'さまざまな市場および指値注文オプション',
			desc5: '取引戦略の柔軟性',
		},
		cqg: {
			desc1: '使いやすい取引インターフェース',
			desc2: '基本的なチャートと分析',
			desc3: 'ヒートマップを含むさまざまな引用スタイルのリアルタイムデータ',
			desc4: '注文とポジションの管理',
			desc5: 'RSS ニュース',
		},
		thanksForYourInterest: 'ありがとうございます',
		weWillContactYou:
			'デモ口座開設のお手続きにあたり、弊社の担当が追ってご連絡いたします。もしメールが届かない場合は弊社にお問い合わせください。',
		createAccountToDownload:
			'このプラットフォームをダウンロードするにはアカウントを作成してください',
		createAccount: '口座を開設する',
		platformNotCovered:
			'口座タイプが異なるため、プラットフォームをインストールするには口座を開設してください',
		btn_downd: 'ダウンロード',
		btn_launch: 'ウェブ版を起動',
		btn_request: 'ダウンロード可能',
		okay: '閉じる',
		continue: '次へ',
		requestAccount: '口座の申請',
		disabledOptionAlert:
			'ダウンロードを開始できません。10秒ほどお待ちいただき再度お試しください。',
		modal_reminder: {
			title: '口座をお持ちですか',
			descript1:
				'にアクセスするにはメールにてお送りしました口座情報をご利用ください。まだ口座をお持ちでない場合は申請へとお進みください。口座開設がお済みでない場合はアクセス出来かねます。',
			descript2: '',
			descript3: '',
			descript1sub: ' にアクセスするには',
			descript2sub:
				'メールにてお送りしました口座情報をご利用ください。まだ口座をお持ちでない場合は申請へとお進みください。口座開設がお済みでない場合はアクセス出来かねます。',
			descript3sub: 'アクセスにはアカウントが必要です',
		},
		modal_send: {
			title: 'あなたのリクエストは送信されました',
			descript:
				'トレードビューへようこそ！ご希望のプラットフォームにて口座開設手続きへと進ませていただき担当からご連絡いたします。もしメールが届かない場合は弊社にお問い合わせください。',
		},
		acessPlatforms:
			'これらのプラットフォームにアクセスするにはアカウントが必要です。',
		acessPlatformsContinue: 'からご申請いただけます。',
		webVersionModal: 'Web版を起動',
		toAccess:
			'MT5 にアクセスするには、メールで送信された認証情報を使用してください。このプラットフォームのアカウントをまだリクエストしていない場合は、今すぐ、またはいつでもリクエストできます。アクセスにはアカウントが必要です。',
		selectTypeAccount:
			'Web版を起動するために使用するアカウントの種類を選択してください：',
		live: 'ライブ',
		demo: 'デモ',
		launch: '起動',
	},

	//History page
	history: {
		titleH: '取引履歴',
		periodTimeL: '期間',
		periodTimeP: 'すべての履歴',
		typeL: '項目',
		typeP: '項目を選ぶ',
		platformL: 'プラットフォーム',
		platformP: '選択してください',
		accountL: 'トレード口座',
		accountP: '口座番号',
		fromL: 'データ開始',
		fromP: '月／日／年（西暦）',
		toL: 'データ終了',
		toP: '月／日／年（西暦）',
		clearBtn: '消去',
		exportBtn: 'データ出力',
		getBtn: 'レポート作成',
		optionsAccounts: '口座番号',
		infoAlertD: '口座を選択し表示する',
		noHistoryYet1: '選択したアカウントのフィルタ',
		noHistoryYet2: 'まだ履歴はありません',
		platformAlertD:
			' ご注意：フィルターおよび下の表にはMT4、MT5、cTrader 口座のみが表示されます。他の口座タイプはプラット <br>   フォーム内で取引履歴にアクセスしてください。',
		accountTypeH: '口座タイプ',
		accountTypeP: '口座タイプの選択',
		alertExport: 'データが作成されました',
		btnFilter: 'フィルター',
		alertPlatforMobile: 'MT4、MT5、Cトレーダーに対応しています',
		modalHeader: 'ページを閉じます',
		modalDescription:
			'現時点でページを閉じられますと保存されていない情報は削除されますのでご注意ください',
		btnModalCancel: 'キャンセル',
		btnModalYes: '移動する',
		filterbyactivity: 'フィルター',
		accountTooltip: '取引に関連する口座番号です。<br>  ',
		accountTooltip2: ' は入金を表し、',
		accountTooltip3: 'は出金を表します。',
		accountTooltipIn:
			'この列に表示されている送金元の口座からあなたの照会した口座に入金された振込です。',
		accountTooltipOut:
			'この列に表示されている送金先の口座に送られた、あなたの照会した口座からの出金です。',
		selectActivity: '活動を選択',
	},

	// Withdraw page
	withdraw: {
		sourceAccount: '出金ご希望の口座番号',
		currency: '口座通貨',
		currencyType: '口座通貨',
		details: '送金先の銀行の詳細',
		beneficiaryDetails: '送金先の銀行の詳細',
		swiftt: 'Swift',
		branch: '支店',
		branchCode: '支店名',
		enterbranch: '支店コードを入力してください',
		province: '県名',
		city: '市区町村',
		bank: 'DBS銀行',
		bankK: '銀行',
		bankTransfer: '振込する銀行を選択してください',
		withdrawFunds: 'ご出金',
		withdrawalMethod: '出金方法',
		withdrawalAmmount: '出金可能な金額',
		keepInMind: 'ご注意：',
		keepInMindTC: '24時間以内に最大5回の取引が可能です。',
		withdrawalCalendar:
			'会計部署は週末はお休みとなりますため、手続きは週明けに行われます。会計監査機関の依頼に準じ、<br> 毎月４回目以降の出金やマネー ロンダリングが疑われる出金依頼は保留となります。',
		withdrawalMustMatchDeposit:
			'出金方法は入金方法と同じである必要があります。クレジットカードで入金された場合は、入金額を超える金額は別の出金方法でご申請ください。4回目以降の出金には50ドルの手数料が発生します。',
		beneficiaryName: '受取人の名前',
		bankAddress: '銀行住所',
		enterBankAddress: '銀行の住所を入力してください',
		enterBeneficiaryName: '受取人の名前を入力してください',
		beneficiaryAddress: '受取人住所',
		enterBeneficiaryAddress: '銀行名を入力してください',
		enterYourAddress: '銀行の住所を入力してください',
		accountNumber: '口座番号',
		iban: '(IBAN)',
		aliasiban: '（オプション）',
		enterAccountNumber: '銀行口座番号を入力してください',
		bankName: '銀行名',
		enterBankName: '銀行名を入力してください',
		swiftCode: '支店コード',
		enterSwiftCode: '銀行のSwiftコードを入力してください',
		enteryourSwiftCode: '支店コードを入力してください',
		aliasSwiftCode: ' （オプション・海外送金の場合は必要です）',
		abaNumber: 'Swiftコード',
		enterAbaNumber: 'スイフトコードを入力してください',
		aliasAbaNumber: '（オプション：海外送金の場合のみ必要）',
		sortCodeClabe: 'Sortコード/CLABE',
		enterSortCodeClabe: 'Sortコード/CLABEを入力してください',
		referenceNumber: '照会番号',
		enterReferenceNumber: '照会番号を入力してください',
		associatedEmail: 'ご登録のメールアドレス',
		associatedEmailLabel: 'ご登録のメールアドレス',
		enterAssociatedEmailAccount: 'メールアドレスを入力する',
		doYouNeedIntermediary: '中継銀行はございますか？',
		selectAnOption: '選択してください',
		pleaseSelectAnOption: '選択してください',
		enterCashAmount: '金額を入力してください',
		helperCashTransfer:
			'最低10米ドル。10,000ドル以上の送金には手動審査が必要です。',
		intermediaryBank: '仲介銀行の詳細',
		intermediaryBankk: '仲介銀行',
		ifNeeded: '（必要に応じて）',
		intermediaryBankName: '中継銀行名',
		banescoAccountName: '口座名義',
		enterAccountName: 'アカウント名を入力してください',
		enterBankName: '銀行名を入力してください',
		clabe: 'CLABE',
		clabealias: '(口座番号)',
		enterclabe: 'CLABEを入力してください',
		pesosAccount: 'ペソ口座番号',
		enterIntermediaryBankName: '中継銀行の名前を入力してください',
		intermediaryBankAddress: '中継銀行の住所',
		enterintermediaryBankAddress: '中継銀行の住所を入力してください',
		ibanNumber: 'IBAN番号',
		enterIbanNumber: 'IBAN番号を入力してください',
		withdrawalCompleted: '出金が完了しました！',
		withdrawalIsComplet: 'リクエストを受け取りました',
		withdrawalIsCompletDescription:
			'出金手続きは通常、営業日内の24-48時間以内に完了致します。<br> 銀行送金の場合は2～5営業日お時間をいただいております。<br> 不備がある場合は担当よりご連絡いたします。',
		withdrawalCompletedDescription:
			'良いニュースです！お客様の資金はまもなく目的の口座に入金されます。処理時間は選択した引き出し方法によって異なる場合があります。',
		withdrawNotCompleted: '出金手続きはまだ完了していません。',
		withdrawNotCompletedDescription:
			'出金の申請中にエラーが発生しました。口座情報を確認し、もう一度お試しください。問題が解決しない場合:',
		contactUs: 'お問い合わせ',
		goToMyAccount: '戻る',
		creditCardDetails: 'クレジットカードの詳細',
		important: 'ご注意:',
		withdrawalsExceeding:
			'最初の入金額を超える金額をクレジットカードに出金することはできません。クレジットカードを使用する場合は、最初に入金した金額と同じ金額のみ出金可能です。利益分を出金する際には、別の出金方法をご利用ください。',
		creditCardLastDigits: 'カード番号の下４桁',
		enterCreditCardLastDigits: 'カード番号の下４桁を入力してください',
		netellerAccountDetails: 'Neteller口座の詳細',
		netellerComission:
			'入金・出金ともに２％の手数料が発生し、この手数料は、資金を３か月（もしくはそれ以上）口座に置いていた場合、もしくは最低ロット数の条件を満たしていた場合は免除されます（ロット数の計算に関しましてはアカウントマネジャーにお問い合わせください）',
		netellerComissionMena:
			'Netellerに関連するコストの増加に伴い、Netellerを介したすべての入出金に対して1％の手数料を請求させていただきます。特定の状況において、Tradeviewの担当者によるアカウントの確認後に手数料が免除される場合もあります。',
		skrillAccountDetails: 'Skrill口座の詳細',
		upholdAccountDetails: 'Uphold口座の詳細',
		bitwalletAccountDetails: 'ビットウォレット口座の詳細',
		interacAccountDetails: 'インタラク e-Transfer アカウントの詳細',
		interacHelpMsg: '*インタラク コープの登録商標。ライセンスの下で使用。',
		upholdComission:
			'Upholdへのアカウントへの出金：手数料なし <br> その他のウォレットへの出金：Upholdプロセス手数料が <br> 発生します。 ',
		bitPayTitle: 'BitPayの詳細',
		destinationAccount: '移動先の口座',
		bitPayCommision:
			'仮想通貨の処理には以下の手数料がかかります：換金手数料（1.05％）、ネットワーク手数料（0.0003 BTC)、出金手数料 (0.0003 BTC)',
		needYourAuth: 'お客様からの承認が必要です',
		confirmThoughtEmail:
			'出金申請フォームを提出後、ご登録のメールアドレスから出金を承認してください',
		wallet: 'ウォレット',
		enterYourWallet: 'ウォレットを入力してください',
		enteryourEmailAccount: 'メールアドレスを入力してください',
		sticPayAccountDetails: 'SticPay口座の詳細',
		voletAccountDetails: 'Volet口座の詳細',
		interacAccountDetails: 'Interac e-Transferのアカウント詳細',
		fasapayAccountDetails: 'Fasapayアカウントの詳細',
		searchABank: '銀行を探す',
		searchAnAccount: 'アカウントを検索',
		ibanIfApplicable: '(該当する場合は IBAN)',
		beneficiaryBankName: '送金先の銀行名',
		enterBeneficiaryBankName: '送金先の銀行名',
		enterYourProvince: '都道府県を入力してください',
		enterYourCity: '市を入力してください',
		unionPayDetails: 'UnionPay口座の詳細',
		jpayDetails: 'JPay口座の詳細',
		walletAndCrypto: 'ウォレット・仮想通貨',
		walletAndCryptoAlert: '弊社で負担いたします',
		crypto: '仮想通貨',
		selectCrypto: '暗号通貨を選択してください',
		tag: '鬼ごっこ',
		enter: '入力',
		cryptocurrency: '仮想通貨',
		enterCryptocurrency: '暗号通貨を入力してください',
		otherCurrency: 'その他の仮想通貨',
		enterOtherCurrency: '他の暗号通貨を入力してください',
		areYouSure: 'ページを閉じます',
		ifYouLeaveNow:
			'現時点でページを閉じられますと保存されていない情報は削除されますのでご注意ください',
		noStay: 'ログインを継続する',
		yesLeave: 'ページをクローズする',
		requestSubmited: 'リクエストが送信されました',
		reviewEmail: 'ご登録のメールアドレスをご確認ください',
		unsuccessfulWithdraw: '出金手続きはまだ完了していません。',
		reviewAgain:
			'出金情報を確認して、もう一度お試しください。問題が引き続き発生する場合は、 ',
		amountTryAgain:
			'金額が譲渡可能額を超えています。もう一度やり直してください。',
		amountTryAgainWithdraw:
			'入力した金額では手続き出来かねてしまいます。再度ご入力ください。',
		minimunAmount: 'この出金方法による最低出金金額は100ドルです。',
		minimunAmount100: 'この方法の最低出金額は 100 米ドルです。',
		minimunAmount0: 'この方法の最小引き出し額は例として0.00001 BTCです。',
		invalidEmail: '正しいフォーマットではありません',
		invalidAccountNumber: '正しいウォレットではありません',
		noAvailableOptions: '利用可能なオプションがありません',
		closeModal:
			'別の画面へ移動すると、入力された情報は全て消去されます。後で出金を申請する際には、情報を入力し直す必要があります。',
		successWithdraw:
			'良いニュースです！お客様の資金はまもなく目的の口座に入金されます。処理時間は選択した引き出し方法によって異なる場合があります。',
		fundCreditCard: 'カード入金',
		selectMethod:
			'出金方法は入金方法と同じものをお選びください。利益出金の場合、カード出金以外のご希望の方法にて手続きが可能です。',
		invalidCreditCardDigits: '無効なカード番号',
		phone: '電話',
		enterYourPhone: '電話番号を入力してください',
		invalidPhone: '無効な電話番号の形式',
		modalPreferences: 'このメッセージを次回から表示しない',
		bankFee: '2100円～35ドル',
		bankBranch: '銀行支店',
		enterBankBranch: '銀行支店を入力してください',
		branchProvince: '支店の都道府県',
		enterBranchProvince: '支店の都道府県を入力してください',
		BranchCity: '支店の市区町村',
		enterBranchCity: '支店の市区町村を入力してください',
	},

	//Account Activity page
	accountActivity: {
		title: 'アカウント活動',
		from: 'データ開始',
		to: 'データ終了',
		type: '項目',
		platform: '取引商品',
		placeholderAccount: 'トレード口座',
		account: 'トレード口座',
		get: 'OK',
		row: 'ページ内項目数',
		download: 'レポートをダウンロード',
		back: '戻る',
		confirm: '決定',
		close: '閉じる ',
		error: 'エラー！空欄を残すことはできません',
		errorTwo: 'エラー！フィールドのタイプを選択する必要があります。',
		activityid: '活動ID ',
		platfomr: 'プラットフォーム',
		date: '日付 / 時間',
		activity: '活動 ',
		profit: '損益',
		timeSegmentation: 'セグメンテーション',
		timeFrame: '期間を選択してください',
		selectType: '項目を選ぶ',
		selectMarket: '選択してください',
		tradingAccount: '口座番号',
		segmentation: 'セグメンテーション',
		segmentationPlaceholder: '期間を選択してください',
		platformPlaceholder: '選択してください',
		alert: 'データが作成されました',
		infoYet: '選択したフィルターでは検索結果がありません。再度お試しください。',
	},

	//tradingHistory
	tradingHistory: {
		title: '取引履歴',
		from: 'データ開始',
		to: 'データ終了',
		type: '項目',
		platform: 'プラットフォーム',
		placeholderAccount: 'トレード口座',
		account: '口座',
		get: 'OK',
		row: 'ページ内項目数',
		download: 'レポートをダウンロード',
		back: '戻る',
		confirm: '決定',
		close: '閉じる ',
		error: 'エラー！空欄を残すことはできませんs',
		errorTwo: 'エラー！フィールドのタイプを選択する必要があります。',
		deal: '取引',
		entryTime: 'エントリーレート',
		typr: '項目',
		simbol: '通貨ペア',
		volume: 'ボリューム',
		entryPrice: 'エントリー時間',
		sl: 'S/L',
		tp: 'T/P',
		exitTime: 'イグジット時間',
		exitPrice: 'イグジットレート',
		commision: '手数料',
		bankFee: '銀行手数料',
		swap: 'スワップ',
		profit: '損益',
		dateFrom: '年/月/日',
		dateTo: '年/月/日',
		openingTime: 'オープン時間',
		openingPrice: 'オープンレート',
		stopLoss: '損切',
		takeProfit: '利確',
		closingTime: 'クローズ時間',
		closingPrice: 'クローズレート',
		comission: '委員会',
		time: '時間',
	},

	//Transfer page
	transfer: {
		mainTitle: '資金を移動する',
		isBackValidation:
			'お振込みの承認には審査が必要です。翌営業日の24時間以内に承認される場合があります。',
		pleaseNote: 'ご注意：資金移動は同じ名義の口座間のみで可能です',
		mena: {
			consentCheck:
				'チェックボックスにチェックを入れることで、Tradeview Ltd.の1つのアカウントから別の自分のTradeview Ltd.アカウントへの資金移動をリクエストしたことを理解したことになります',
		},
		ltd: {
			consentCheck:
				'チェックボックスにチェックを入れることで、私はTradeview Ltd.の1つのアカウントから別の自分のTradeview Ltd.アカウントへの資金移動をリクエストしたことを理解しています。',
		},
		latam: {
			consentCheck:
				'チェックボックスにチェックを入れることで、私はTradeview Financial Markets S.A.C.の1つのアカウントから別の自分のTradeview Financial Markets S.A.C.アカウントへの資金移動をリクエストしたことを理解しています。',
		},
		japan: {
			consentCheck:
				'チェックボックスにチェックを入れることで、私はTradeview Financial Markets S.A.C.の1つのアカウントから別の自分のTradeview Financial Markets S.A.C.アカウントへの資金移動をリクエストしたことを理解しています。',
		},
		markConsentCheck:
			'次に進む前に承認項目に同意する必要があります。ボックスにチェックをしてください。',
		transferAmount: '資金移動可能な金額',
		transferCompleted: '資金移動が完了しました',
		transferReview: '移籍審査中',
		transferInCompleted: '資金移動は完了していません',
		transferInCompletedDescription:
			'資金移動の申請中にエラーが発生しました。口座情報を確認し、もう一度お試しください。',
		transferDescription:
			'資金移動の申請が完了しました。資金が移動先の口座に反映されるまで少々お待ち下さい。',
		transferDescriptionReview:
			'お振込みは現在審査中です。振込手続きが完了しましたら、担当者よりメールにてご連絡させていただきます。',
		destinationAccount: '移動先の口座',
		minimunAmount: '最低額は10ドル（1000円）です',
	},

	//Accounts
	accounts: {
		refresh: '残高を更新',
		liveAccounts: 'ライブ口座',
		demoAccounts: 'デモ口座',

		createLive: '+ 口座開設',
		createDemo: '+ デモ口座の開設',
		refresh: 'データを更新する',
		createAccount: '新規口座開設',
		createDemoAccount: 'デモ口座の開設',
		createLiveAccount: '口座開設',
		livee: 'ライブ',
		demoo: 'デモ',
		yourBalance: '口座残高',
		equityy: '有効証拠金',
		marginLevel: '証拠金維持率',
		freeMargin: '余剰証拠金',
		statuss: 'ステータス',
		leveragee: 'レバレッジ',
		credit: 'クレジット',
		phone: '電話',
		selectLeverage: 'レバレッジの選択',
		noLiveAccount: '現在ライブ口座をお持ちではありません',
		noDemoAccount: '現在デモ口座をお持ちではありません',
		tradingInstrument: '取引市場',
		tradingMethodTooltip:
			'為替やCFDをお取引される場合はFXを選択してください。米国株式をお取引される場合は株式、先物をお取引される場合は先物を選択してください。後ほど追加口座を開設することも可能です。 ',
		here: 'こちら',
		selectAMarket: 'マーケットの選択',
		platform: 'プラットフォーム',
		selectAPlatform: '選択してください',
		cashAmount: '入金額',
		selectCashAmount: '入金額の選択',
		accountType: '口座タイプ',
		selectAnAccount: '口座タイプの選択',
		currencyy: '口座通貨',
		selectACurrency: '口座通貨の選択',
		platformTooltip:
			'プラットフォームとは、トレードする際に利用する取引システムです。ご希望のプラットフォームをお選びください。',
		accountTypeTooltip:
			'ご希望のトレード環境（レバレッジ、スプレッド、コミッション）に合わせて口座タイプをお選びください。',
		accountTypeTooltip2:
			'それぞれのトレード環境の確認にはこちらをご覧ください。',
		applicationCompleted: '口座申請が完了しました',
		applicationCompletedDescription:
			'追加口座申請を受理しました。書類の不備等がございましたら <br> バックオフィス部署から追ってご連絡いたします。もしメールが <br> 届かない場合は弊社にお問い合わせください。',
		applicationError: 'ご申請の送信中にエラーが発生しました',
		applicationErrorDescription: '必須項目をご確認後再度ご申請ください。',
		applicationErrorDescription2:
			'もし改善しない場合は japanesesupport@tvmarkets.com へご連絡をお願いいたします。',
		sureToLeave: 'ページを閉じます',
		processUncompleted:
			'現時点でページを閉じられますと保存されていない情報は削除されますのでご注意ください',
		cardPlatform: 'プラットフォーム',
		setDemoAccount:
			'デモ口座開設手続き中です。開設完了次第こちらのページにて詳細を確認いただけます。',
		cancel: 'キャンセル',
		active: 'アクティブ',
		accountSettings: 'アカウント設定',
		changePw: 'このアカウントのパスワードを変更',
		changeLv: 'このアカウントのレバレッジを変更',
		setLv: 'アカウントの新しいレバレッジを設定',
		underReview: 'リクエストを受け取りました',
		underReviewDesc:
			'レバレッジの変更が完了次第、<br> チームスタッフよりご連絡いたします。',
		successLev: 'レバレッジが正常に更新されました！',
		changePsw: 'パスワードを変更',
		forgotPw: 'パスワードを忘れましたか？ {contact} までご連絡ください。',
		updatePw: 'パスワードが正常に更新されました！',
		statusTooltip:
			'ライブ口座：必要な書類の期限切れや情報が不足している場合、アカウントが非アクティブになることがあります。<br> デモ口座：デモ口座の有効期限は90日間のため、それ以降は非アクティブ口座となります。引き続きデモ口座のご利用をご希望の場合は新たにデモ口座をご申請ください。<br> 原因が不明な場合は {contact} までご連絡ください。',
		failedReq: '申し訳ございません！エラーが発生しました',
		failedReqDesc:
			'もう一度お試しください。問題が続く場合は、{contact} にお問い合わせください。',
		forex: 'Forex and CFDs',
	},

	//CreateDemoAccounts
	demoAccounts: {
		login: 'ログイン',
		pass: 'パスワード',
		currencyTwo: '口座通貨',
		server: 'サーバー',
		ilc: 'iLC',
		xleverage: 'xLeverage',
		dontForget:
			'ログインIDとパスワードを保存してください。デモ口座情報はご登録のメールアドレスへも送信されます。',
		downloadCred: 'ログイン情報の保存',
		choosePlatform: 'プラットフォームを選択後、ダウンロードをしてください',
		ifYouChooseMT4:
			'Mac OSにてMT4をダウンロードされる場合、インストール方法が異なりますのでこちら',
		ifYouChooseMT4continuation: 'から詳細をご確認ください',
		thanksForRegistering: 'ご登録ありがとうございます!',
		otherStock:
			'デモ口座開設のお手続きにあたり、弊社の担当が追ってご連絡いたします。もしメールが届かない場合は弊社にお問い合わせください。',
		stockMT52: '口座開設が完了しましたらご連絡を差し上げます。 ',
		stockMT53: 'もしメールが届かない場合は ',
		stockMT54: '弊社にお問い合わせください。',
		accountTypeDemo:
			'口座タイプにより適応可能レバレッジが異なります。<br><br> iLC: 1:200 <br> X-レバレッジ: 1:500 <br>株式: 1:3',
		applicationCompleted: 'アカウントが作成されました',
		// pdfCredentialTitle: 'トレーダーの皆様へ',
		// pdfCredentialDescription1:
		// 	'トレーディングの旅を始めるにあたって、私たちを選んでいただきありがとうございます。',
		// pdfCredentialDescription2: '一緒に取り組めることを嬉しく思います。',
		// pdfCredentialDescription3: 'こちらがあなたのアカウントの認証情報です：',
		// pdfCredentialEmail: 'メールアドレス：',
		// pdfCredentialPassword: 'パスワード：',
		// pdfCredentialCurrency: '通貨：',
		// pdfCredentialServer: 'サーバー：',
		// pdfCredentialInstructions: '手順：',
		// pdfCredentialInstructions2: '登録したメールアドレスとパスワードを使用して',
		// pdfCredentialTo: 'で',
		// pdfCredentiallogin: 'ログイン',
		// pdfCredentialTVAccount: 'Tradeviewアカウントにログインしてください。',
		// pdfCredentialChangeP:
		// 	'パスワードを変更したり、2要素認証を設定することができます。',
		// pdfCredentialSettings: 'キャビネットの「設定」セクションで。',
		// pdfCredentialFamiliarize: 'プラットフォームに慣れて、機能を探り、',
		// pdfCredentialExperience: 'Tradeviewの違いを体験し始めてください。',
		// pdfCredentialSupport:
		// 	'私たちは常にあなたをサポートする準備ができています。質問がある場合や',
		// pdfCredentialNeed:
		// 	'支援が必要な場合は、専任のサポートチームにお気軽にお問い合わせください。',
		// pdfCredentialTeam: 'サポートチーム。',
		// pdfCredentialHappy: '楽しいトレーディングを！',
		// pdfCredentialRegards: 'よろしくお願いします。',
		// pdfCredentialTVTeam: 'Tradeviewチームより',
	},

	//Create Live Accounts
	liveAccount: {
		login: 'ログイン',
		pass: 'パスワード',
		server: 'サーバー',
		platform: 'プラットフォーム',
		status: 'ステータス',
		statusFalse: '有効',
		statusTrue: '無効',
		dontForget:
			'ログインIDとパスワードを保存してください。デモ口座情報はご登録のメールアドレスへも送信されます。',
		downloadCred: 'ログイン情報の保存',
		applicationCompleted: 'ライブアカウントが作成されました！',
	},

	//credit card
	credit: {
		edit: '変更',
	},

	//Banck Transfer add found Skrill
	addFounds: {
		amount: '金額',
	},

	//fidelity
	fidelity: {
		routingNum: 'ルーティング番号',
		swiftCodebic: 'SWIFTコード/BIC',
		disclaimer:
			'これらの入金手順はケイマン諸島の居住者のみに適用されます。ケイマン諸島からの送金でない場合は他の銀行をご利用ください。',
	},

	//Bbva
	bbva: {
		ruc: 'RUC',
		accountninfo: '0011-0351-0100035781',
		nameBenef: '受取人名',
		interbank: 'インターバンク番号（CCI）',
	},

	//deposit
	deposit: {
		title: '入金方法を選択してください',
		depositMethod: '入金方法',
		processingCards: '処理日数',
		fee: '料金',
		crypto: 'クリプト (Crypto)',
		digitalWallets: '電子ウォレット',
		cardTransfer: 'カード入金',
		wireTransfer: '銀行送金',
		btnDepositFunds: 'ご入金',
		selectAnOption: '入金方法を選択してください',
		depositUnderReview: '入金は審査中です',
		depositUnderReviewDescription:
			'あなたの入金は現在審査中です。入金処理が完了次第、チームがメールでご連絡いたします。',
		depositUnderReviewErrorDescription:
			'入金処理中に問題が発生しました。お支払い情報を確認して、再度お試しください。問題が続く場合は、当社にご連絡ください。',
		depositCompleted: '入金が完了しました！',
		depositCompletedDescription:
			'ご入金が口座に反映されるまでお待ちください。反映までのお時間は入金方法によって異なります。',
		despositInCompletedDescription:
			'入金の処理中に問題が発生しました。お支払い情報を確認して、もう一度お試しください。問題が続く場合',
		contactUs: 'お問い合わせ',
		depositNotCompleted: '入金は完了していません',
		depositNotCompletedDescription:
			'ご入力情報をご確認いただき再度お試しください。もし改善しない場合は japanesesupport@tvmarkets.com へご連絡をお願いいたします。',
		depositWithClick: 'または、下記をクリックし素早い入金も可能です。',
		keepInMind: 'ご注意：',
		keepInMindTC: '24時間以内に最大5回の取引が可能です。',
		ltd: {
			depositDisclaimer:
				'損失が元本を超える場合があります。第三者による入金は受け付けられません。すべての入金はアカウント所有者によって行われなければなりません。取引プラットフォームの通貨は米ドルです。Tradeview Ltd.は、出金の代わりにクレジットカードで行われた入金を返金する権利を留保します。',
		},
		latam: {
			depositDisclaimer:
				'損失が元本を超える場合があります。第三者による入金は受け付けられません。すべての入金はアカウント所有者によって行われなければなりません。取引プラットフォームの通貨は米ドルです。Tradeview Financial Markets S.A.C.は、出金の代わりにクレジットカードで行われた入金を返金する権利を留保します。',
		},
		accountNumberTitle: '取引口座番号',
		accountNumberDescription: '資金を入金する口座を選択してください',
		currencyTitle: '口座通貨',
		currencyDescription: '口座通貨の選択',
		amountTitle: '金額',
		amountDescription: '金額を入力してください',
		phoneNumberTitle: '電話番号',
		confirmTitle: '取引内容を確認',
		confirmDescription: '以下の内容が正しいことをご確認ください：',
		upholdCommission:
			'仮想通貨の取引手数料はお客様負担となります。手数料は送金する金額により決まります。',
		upholdBanningTitle: '使用が不可能な地域',
		upholdBanningDescription:
			'Upholdは以下の国にお住いのお客様にはご利用いただくことができません。',
		depositAmount: '入金額を入力してください。',
		btcAlertTitle: 'BTC入金手数料',
		btcAlertMessage:
			'すべての取引にBTC Fiatの換金手数料が適用されます。25万ドルまでの取引には1%、25万ドルを超える取引には1.5%の手数料がかかります。',
		upholdWarningTitle: 'BTCでの入金手数料',
		upholdWarningMessage:
			'$250000までの取引にはBTC-Fiat変換手数料1%、$250000を超える取引には1.5%の手数料がかかります。',
		bitPayCommission:
			'暗号通貨取引手数料はユーザーの負担となります（金額は送金金額に応じて異なります）。',
		bitPayWarningTitle: '暗号処理業者の手数料は以下の通りです: ',
		bitPayWarningMessage:
			'交換手数料: 1.05%   ットワーク手数料: 0.0003 BTC  引き出し手数料: 0.0003 BTC',
		bitpayFooterInfo:
			'Tradeviewは入金処理中の為替レート変動による利益や損失について責任を負いませんのでご留意ください',
		interacFooterInfo:
			'Tradeview Financial Markets S.A.C. は、出金処理の代わりにクレジットカードで行われた入金を返金/払い戻しする権利を留保します',
		tetherWarningTitle: '手数料',
		tetherWarningMessage:
			'暗号通貨を使用して入金する際には0.7%の変換手数料がかかります',
		copied: 'コピーされました',
		tetherHashTitle: 'ハッシュ',
		tetherHashDescription: '送金後表示されるハッシュを入力してください',
		tetherTooltip:
			'ハッシュは暗号技術を用いて生成される数字と文字からなるコードです',
		netellerFooterInfo:
			'損失は投資した元本を超える可能性があります。第三者による入金は受け付けておりません。すべての入金は口座所有者によって行われなければなりません。取引プラットフォームの通貨は米ドルです。Tradeview Ltd. は、出金処理の代わりにクレジットカードによる入金を返金する権利を有します。',
		fasapayAccountTitle: 'ファサペイ口座',
		fasapayAccountDescription: 'FasaPayアカウントIDを入力してください',
		jpayFooterInfo: '為替レート: 1 USD = 7 CNY (RMB)',
		addressTitle: '住所',
		zipCodeTitle: '郵便番号',
		zipCodeDescription: '郵便番号を入力してください',
		countryTitle: '国',
		countryDescription: '国を選択してください',
		cityTitle: '市区町村',
		cityPlaceholder: '都市を選択してください',
		skrillFooterInfo:
			'損失は投資した元本を超える可能性があります。第三者による入金は受け付けておりません。すべての入金は口座所有者によって行われなければなりません。取引プラットフォームの通貨は米ドルです。Tradeview Ltd. は、出金処理の代わりにクレジットカードによる入金を返金する権利を有します。',
		bitwalletFooterInfo:
			'損失は投資した元本を超える可能性があります。第三者による入金は受け付けておりません。すべての入金は口座所有者によって行われなければなりません。取引プラットフォームの通貨は米ドルです。Tradeview Ltd. は、出金処理の代わりにクレジットカードによる入金を返金する権利を有します。',
		clickBank:
			'希望する銀行の名前をクリックして、必要な口座情報にアクセスし、銀行のプラットフォームを通じて入金を簡単に完了させてください。振込が完了したら、取引明細書をブローカーに送信して検証を受けてください。検証が完了次第、資金が速やかに取引口座に追加され、シームレスで効率的なプロセスが確保されます。',
		banks: '銀行',
		processingTime: '処理日数：',
		commision: '手数料：',
		bankProcessingTime: '処理時間：約1〜2営業日',
		bankCommision: '手数料：なし',
		sameDay: '当日',
		depositInstructions:
			'これらの入金手順はケイマン諸島の居住者のみに適用されます。ケイマン諸島からの送金でない場合は他の銀行をご利用ください。',
		downloadInfo: '情報のダウンロード',
		intermediaryBank: '中継銀行名',
		intermediarySwift: '中継銀行スイフトコード',
		beneficiarySwift: '銀行スイフトコード',
		beneficiaryBank: '銀行名銀行名',
		paymentProvider: '支払いプロバイダーの住所',
		accountHolder: '口座名義人',
		virtualIban: '仮想IBAN',
		bic: 'BIC',
		createLiAcc: 'ライブ口座の開設',
		waitTitle: '新しいタブロード中',
		waitDescription:
			'ウィンドウを閉じないでください。新しいタブが開かれますのでそちらにてお進みください。お待ちいただく間別のウィンドウのご利用は可能です。',
		depositTypeTitle: '入金タイプを選択してください',
		depositTypeDescription: 'ご希望の入金方法をお選びください',
		typeCash: '現金送金',
		typeBankTransfer: '銀行送金',
		countryBankTitle: '入金方法',
		countryBankDescription: '入金方法をお選びください',
		minimumAmount: '最小金額',
		maximumAmount: '最大金額',
		is: 'は',
		pleaseNote: 'ご注意：',
		validateDeposit:
			'送金が完了しましたらサポートに送金明細書を提出しご報告ください。確認後、資金さすぐに取引口座に反映され、スムーズで効率的な処理が保証されます。',
		withdrawalchooseMatch:
			'金融規制に準じ、ご出金方法は入金方法と同じである必要がございます',
		notResponsibleDuringTransactions:
			'トレードビューは入出金の際の通貨換算に伴う利益、また損益の責任は一切負いかねます',
		creditCards: 'クレジットカード',
		minDeposit: 'この方法の最低入金額は100.00ドルです',
		cryptos: {
			comission: {
				title: '手数料',
				text: 'Tradeviewは入金手数料を請求しません。プロセッサーからの手数料が発生する場合はございます。',
			},
			scanText1:
				'取引アプリのスキャン機能を使ってこのQRコードをスキャンしてください。',
			scanText2: 'または、以下の暗号通貨アドレスを手動でコピーしてください：',
			copyText:
				'以下の暗号通貨アドレスをコピーして、取引アプリに貼り付けてください：',
		},
		processTimeSameDay: '即時～数時間・週末入金の場合は週明け',
		processTimethreeDay: '最大3日間',
		commisionYes: 'はい',
		commisionNo: 'なし',
		onReviewTitle: '審査中です',
		onReviewText:
			'ご入金リクエストを受け取りました。確認出来したい口座に反映されます。',
		bitPayFees: 'クリプト・プロセッサーより以下の手数料が発生します：',
		bitPayExchange:
			'為替手数料: 1.05% <br> ネットワーク料金: 0.0003 BTC <br> 出金手数料: 0.0003 BTC',
		minimumAndMaxiumAmountInterac: '最低 $75 CAD - 最高 $9,999 CAD',
		routingNumber: 'ルーティング番号（ABA）',
		beneficiaryBankAddress: '受取銀行住所',
		beneficiaryAccountNumber: '受益者口座番号',
		beneficiaryAccountName: '受益者口座名',
		paymentDetailsFFC: '支払詳細 FFC',
		iban: 'IBAN',
		swiftBic: 'SWIFT/BIC',
		currencies: '通貨',
		sortCode: '支店コード',
		entersortCode: '支店コードを入力してください',
		beneficiary: '受取人',
		beneficiaryIBAN: '受取人IBAN/口座',
		cci: 'CCI',
		moreInformationTitle: '追加情報が必要です',
		moreInformationText:
			'あなたの預金の合計が25,000米ドル以上に達した場合、一度限りの追加確認が必要です。預金を完了するには、「続行」をクリックして、要求された雇用および財務の詳細を提供してください。',
		moreInformationTextLTD:
			'一度限りの追加認証が必要です。入金を完了するには、「続行」をクリックして、求められている雇用および財務情報を提供してください。',
		selectMethod: 'カード入金プロバイダー',
		cryptoMena: 'この情報は暗号通貨の支払いに一度だけ必要になります。 ',
		noOptions: '利用可能なオプションはありません',
		digitalWalletsDisclaimer:
			'• 損失は初期投資額を超える可能性があります。<br> • 第三者からの入金は受け付けません。 すべての入金は口座名義人によって行われる必要があります。<br> ',
		continueWithMyExchangeApp: '取引アプリで続ける',
		continueWithPayX: 'PAY Xで続ける',
		orDepositDirectly: 'または直接入金：',
		maximumAmountPSE_COL: 'PSE決済方法の場合、最大金額は600 USDです。',
		swiffyFooterInfo:
			'Tradeview Ltd. は、出金を処理する代わりにクレジットカードで行われた入金を返金・払い戻しする権利を留保します。',
	},

	//Email
	email: {
		company: '会社ニュース',
		selectOne: "トレードニュース (Surf's Up!)",
		selectTwo: "Surf's Up!",
		update: '設定を保存する',
		manageSubscription:
			'ご希望のニュースレターのトピックをお選びいただきサブスクリプションの管理をしてください',
		dontReceiveEmails:
			'下記トピックのメール配信を停止される場合はトピックのボックスのチェックを外し設定を保存してください',
	},

	//password
	password: {
		title: 'パスワードを変更する',
		subTitle:
			'パスワードを変更するには、電子メール アカウントにワンタイム コードをリクエストしてください。',
		request: 'リクエストコード',
		submit: '送信',
		code: 'コード',
		current: '現在のパスワード',
		confirm: '新しいパスワードを確認',
		setPasswordPreference: 'アカウントの設定',
		mailingSubscriptions: {
			title: 'ニュースレターの購読',
			description: 'こちらでニュースレターやメール購読の管理ができます',
			subscriptionUpdated: 'サブスクリプションが保存されました',
			subscriptionError:
				'何かがうまくいきませんでした。サポートにお問い合わせください。',
		},
		passwordSettings: {
			title: 'パスワード設定',
			description:
				'口座のセキュリティーのためパスワードはこちらでいつでも変更が可能です',
		},
		factor2Verification: {
			title: '2段階認証の設定',
			description:
				'プロトコルを追加することでログイン毎にコードを受け取ることができ、許可のないアクセスから口座を守ることができます',
			firstStepTitle: '認証アプリをダウンロード',
			firstStepFirstParagraph:
				'モバイルデバイスに認証アプリ「Google Authenticator」をダウンロードしてください。Play StoreまたはApple Storeで検索いただけます。',
			firstStepSecondParagraph:
				'2段階認証を有効にすると、パスワードと認証アプリに表示されるコードの両方を入力する必要があります。',
			turnOn: '有効にする',
			secondStepTitle: '認証コードを入力',
			scanQRCode:
				'認証アプリで以下のQRコードをスキャンし、認証アプリに表示される6桁のコードを入力します',
			enterCodeManually: '認証アプリに表示される6桁のコードを入力してください',
			invalidCode: 'コードが正しくありません。再度お試しください。',
			authCompleted: 'プラットフォーム上での認証コードが正常に完了しました',
			disable: '無効にする',
			succesfullyActivatedAuth:
				'アカウントに追加のセキュリティが設定されました。設定を変更する場合は「無効」ボタンをクリックしてください。',
			deactivatedNotification: '２段階認証を無効にしました',
			insertCode: '２段階認証コードを入力してください',
			downloadAuth: 'Google Authenticatorをダウンロード',
			enterAuthCode: '認証コードを入力',
			codeSuccess: 'プラットフォーム上での認証システム設定が正常に完了しました',
		},
		accountPreferences: 'アカウントの設定',
		changeYoutPassword: 'パスワードの変更',
		requestChangePassword:
			'パスワードの変更をご希望の場合はご登録のメールアドレスにコードをお届けします',
		requestCode: 'コードをリクエストする',
		didntGetIt: 'コードを送信する ',
		tryAgain: '再度お試しください。',
		enter6DigitCode: '６桁の認証コード（例：123456）',
		enterValidOTP: 'コードが正しくありません。再度お試しください。',
		notYourCurrentPassword: 'こちらは現在のパスワードではありません',
		passwordConditions:
			'パスワードは8文字以上で、少なくとも1つの小文字、1つの大文字、1つの数字、および1つの特殊文字を含める必要があります',
		passwordsDontMatch:
			'入力したパスワードが一致しません。もう一度確認してください。',
		newPassword: '新しいパスワード',
		confirmPassword: 'パスワードの確認',
		passwordSuccessfulyChanged: 'パスワードが正常に更新されました',
		sampleEmail: 'コードをへ送信いたしました ',
		cantResendCode:
			'現在、コードを再送信することができません。もう一度お試しください。',
		enterCurrentPassword: '現在のパスワードを入力してください',
		enterNewPassword: '新しいパスワードを入力してください',
		enterConfirmNewPassword: '新しいパスワードを確認してください',
		passwordUpdated: 'パスワードが正常に更新されました',
		successful2Factor: '２段階認証の設定が完了しました',
		areYouSure: '無効にしますか？',
		changePasswordDescription:
			'お客様の口座設定を変更し、サブスクリクションを管理し、アカウントの安全性を確保します。',
	},

	//Contact
	contact: {
		requestCall: '電話をリクエストする',
		phoneNumber: '電話番号',
		preferedTime: '希望時間',
		selectPreferedTime: '電話をかける時間を希望の時間を選択してください',
		enterPhone: '電話番号を入力してください',
		knowMore: 'トレードビューに関して',
		callSchedule: '通話がスケジュールされました',
		callScheduleDescription:
			'エージェントの 1 人が通話に割り当てられるとすぐに連絡します。この電話は、リクエストから24時間以内に、次の営業日から開始されますのでご注意ください。',
		failedToSchedule: '通話のスケジュールを設定できませんでした',
		contactUsErrorCall:
			'ご不便をおかけして申し訳ございません。もう一度お試しください。問題が解決しない場合は、他の利用可能なオプションを使用して当社にご連絡ください。',
		weWillContactYou:
			'当社のサービスエージェントの1人が、選択した時間枠内にご連絡いたします。',
		unableToContactYou:
			'残念ながら、現時点では電話をスケジュールすることはできませんでした。情報を再確認して、もう一度お試しください。',
		infoInvalid:
			'入力事項にエラーあります。必須項目をご確認後再度お試しください。もし改善しない場合は japanesesupport@tvmarkets.com へご連絡ください。',
		inNeedOfHelp: 'ご不明な点がございましたらお知らせください',
		inNeedOfHelpDescription:
			'ご申請された口座の進捗状況から口座詳細の確認までお気軽にご連絡ください',
		chatDescription:
			'チャットでより快適に感じますか?私たちはただのメッセージです!',
		chatDescription1:
			'私たちのエージェントは、米国の平日に24 / 7利用可能です。',
		mailForward:
			'メールでお問い合わせください。できる限り早くご返答をさせていただきます。',
		emailUs: 'メールを送る',
		letsChat: 'チャットしよう',
		scheduleACall: '通話をスケジュールする',
		contactDisclaimer:
			'ご希望の場合は、operation@tvmarkets.com 宛てに電子メールで直接お問い合わせいただくこともできます。',
		orVia: '',
		stayConnected: '当社とのつながりを保つ',
		timeZone: 'タイムゾーン',
		selectTimeZone: 'タイムゾーンを選択してください',
		customDate: '日時を選択します',
		soonAsPossible: 'できるだけ早く',
		callWhen: 'いつお電話すればよいですか?',
		contactHelper:
			'注意: スケジュールされた電話通話は英語のみで行われます。 「できるだけ早く」オプションを選択した場合、翌営業日の24時間以内にご連絡いたします。',
		selectDate: '日付を選択',
		selectTime: '時間を選択',
		selectOption: 'トレード期間',
		preferredDate: '希望日',
		sendEmail: 'メールをお送りください',
		subject: '件名',
		describeEmail: '口座をお持ちの場合は口座番号もご記入ください',
		concerns: 'お問い合わせ：',
		yourMessage: 'メッセージ',
		emailSuccessful:
			'メールは受理されました。担当部署からご連絡いたします。もしメールが届かない場合は、 japanesesupport@tvmarkets.com へご連絡ください。',
		emailSuccessfulTitle: 'メールは受理されました',
		emailErrorfulTitle: 'エラーが発生しました',
		emailErrorMessage:
			'エラーが発生しました。必須項目をご確認後再度お試しください。もし改善しない場合は japanesesupport@tvmarkets.com へご連絡をお願いいたします。',
		japanNotice:
			'日本標準時の場合、電話は午後10時から午前12時または午前6時のみご利用いただけます。ご不便をおかけして申し訳ございません。',
		messageError: '９００字以内でご入力してください',
		messageErrorShort: '１５字以上ご入力してください',
		titleError: '件名は６０字以内でご入力してください',
		titleErrorShort: '件名は４字以上でご入力してください',
		preferredDate: '希望日',
		failedAttempt: 'よろしくお願いします、遅刻させていただきます',
		callDate: '通話のスケジュールが設定されました',
		contactSetDate: '「選択した日時で当社の担当者がご連絡いたします:',
		errorPhoneNumber: '電話番号には文字や記号を含めることはできません',
		callDescription:
			'エージェントとお話ししませんか？あなたの時間を大切にしています。都合の良い時間を予約してください！エージェントとお話ししませんか？あなたの時間を大切にしています。都合の良い時間を予約してください！ ',
	},

	//menu
	menu: {
		appli: 'アプリケーション',
		account: 'アカウント',
		platforms: 'ダウンロード',
		history: '口座履歴',
		deposit: 'ご入金',
		transfer: '資金移動',
		withdraw: 'ご出金',
		tradingTools: '取引ツール',
		settings: '設定',
		passwordsettings: 'パスワード設定',
		emailsettings: 'メール設定',
		authenticationsettings: '認証設定',
		contactUs: 'お問い合わせ',
		accessDemo: 'デモアカウントにアクセス',
		accessRestricted: 'アクセス制限中',
		btnReSubmit: '書類を再提出',
		temporarilyUnavailable: 'これらの機能は一時的に利用できません',
		sorryFeature:
			'申し訳ありませんが、アクセスしようとしている機能はまだ利用できません。申請手続きが完了し、アカウントが設定されると、これらの機能にアクセスできるようになります。',
		btnContinue: '続ける',
		liveFeature: 'これらはライブアカウントの機能です',
		featureOnly:
			'アクセスしようとしている機能はライブアカウントのみで利用可能です。今すぐライブアカウントを作成してアクセスしてください。',
		call: '時間がないですか？サポートチームは24/5のGMTでお電話一本で対応します。',
		chat: 'チャットがいいですか？それならそれをしましょう。私たちのエージェントはアメリカの営業時間中、24時間対応しています。',
		mail: 'こちらよりメールをお送りください。<br> 日本語デスク スタッフが返答します。',
		call2: 'お電話ください',
		chat2: 'チャットで話しましょう',
	},

	//sidebar applications process
	sidebar: {
		help: 'お困りですか',
		call: '胼胝',
		chat: 'チャットしてみよう',
		mail: 'メールで問い合わせる',
		notReady: 'ライブ口座を開設する準備ができていませんか？',
		btnDemo: 'デモ口座開設',
	},

	//form signature
	formSignature: {
		authorised: 'クライアントの署名、上記よりご署名ください。',
		or: 'または',
		accept: '署名の確定',
		error1: '署名の確証が完了しておりません。確証へとお進みください。',
		drop: 'ここにファイルをドロップするか、',
		browse: ' ブラウズ',
		make: 'ファイルサイズは2MB以下のものを、また書式はJPEG、PNG、またはPDFのみ受付が可能です。',
		error_help:
			'署名のアップロードが完了しておりません。アップロードへとお進みください。',
	},

	//Text of application process form
	applicationForm: {
		liveIndividual: '個人アカウント <br>  (ライブ口座を開設する)',
		liveJointAccount: 'ライブ共同アカウント',
		primaryAccountHolder: '主なアカウント所有者',
		title: '個人情報',
		subtitlePlatform:
			'一度口座開設していただきますと、次回よりフォームへのご記入は必要なく、追加口座をご希望の取引設定に合わせて開設申請していただけます。',
		subtitleDocument: '検証にはどのような種類の文書を使用しますか?',
		subtitleResidence: '確認にはどのタイプの居住証明を使用しますか?',
		subtitleExperience:
			'外国為替、株式、先物、デリバティブ、またはCFDの取引経験を最もよく表しているオプションを選択してください。',
		submitContact: 'お問い合わせ',
		drop: 'ファイルをここにドロップするか、',
		browse: 'ブラウズ',
		make: 'ファイルサイズは2MB以下のものを、また書式はJPEG、PNG、またはPDFのみ受付が可能です。',
		makeMaxSize:
			'ファイルサイズは15MB以下のものを、また書式はJPEG、PNG、またはPDFのみ受付が可能です。',
		tryAgain: '再度お試しください。',
		openFile: 'ファイルを開く',
		submitted: '申請書の提出が完了いたしました。ただ今、審査を行っております。',
		thankyou: 'この度は弊社に口座申請をいただきありがとうございました。',
		operations:
			'これより審査を開始し、口座開設に向けてのお手続きを進めさせていただきます。追加書類のご提出が必要な場合や、書類・情報に不備があった場合は、弊社のオペレーション・チームがご連絡いたします。',
		appreciate:
			'口座開設までお待ちください。引き続きどうぞよろしくお願いいたします。',
		gotocabinet: 'マイ・キャビネットへ移動',
		explore: 'トレードビューについてもっと詳しく知る。',
		acknowledgementText:
			'下記に電子署名することで、これまでの申請の過程の全てのドキュメントに記載されている全ての情報について認め、同意いたします。',
		acknowledgementTextLATAM:
			'同意のチェックボックスを選択し署名する前に、以下の項目をご確認ください。',
		jointConsent:
			'同意ボックスへのチェック、また電子署名をいただく前に以下の項目をご確認ください。',
		secondaryAccount: 'セカンダリホルダーの追加',
		secondaryAccountDesc:
			'アカウント設定を完了するには、2 番目のアカウント所有者を作成する必要があります。 ',
		primaryAccountHolder: '主なアカウント所有者（あなた）:',
		secondaryAccountHolder: 'セカンダリアカウント所有者:',
		corporateResol: 'Corporate resolution (役員様が2名以上の場合)',
		corporateResolDisclaimer:
			'ファイルをドラッグしていただくか、選択してご提出ください。',
		corporateResolDisclaimer2:
			'JPEG・PNG・PDFのいずれかのファイルで、サイズは３MB以下であることを確認してください。',
		corporateResolDesc:
			'{link} をクリックし、Tradeview の標準企業決議フォームをダウンロードして記入するか、独自の決議フォームを送信することができます。',
		shareHolder: '株主の情報',
		shareHolderDesc:
			'法人株の10％以上を保有する株主の方を9名まで追加ができます。必要がない場合は次へお進みください。',
		addShareholder: '株主を追加する',
		or: 'または',
		completeShareholder: '株主情報を入力してください',
		shareholder: '株主',
		information: '情報',
		aboutToComplete: '株主#{number}の情報を入力しようとしています',
		noShareAvailable:
			'株主と口座保有者の合計割合は100％を超えることはできません。もう一度お試しください。',
		percentageLow:
			'株主と口座保有者の合計割合は100％である必要があります。ご確認ください。',
		aboutToCompleteDesc:
			'開始する前に、株主#{number}の以下の書類を準備してください:',
		accountHolderDisclaimer:
			'会社の株式を{percentage}以上保有している株主には、個人情報、本人確認書類 、住所証明書を要求します。{percentage}未満の株主には、名前と苗字のみを要求します。',
		deleteShareholder:
			'保有株を編集するか、株主の本人確認書類および住所証明書をアップロードするには、既存のエントリーを削除して再度追加してください。',
		sendInvitation: 'リクエストの送信',
		pendingShareholderTitle: '株主様の情報が揃っておりません',
		pendingShareholderDesc: '株主情報のご入力を完了し、次へお進みください。',
		inviteSentSuccess: 'リクエストが送信されました',
		inviteSentSuccessDesc:
			'こちらのページで株主が必要事項・書類の提出完了か確認いただけます。',
		primaryHolder: '代表者（あなた）',
		sharePercent:
			'株は会社の所有権を表します。所有株数を提示することで所有権の割合が示されます。',
		accountHolder: '代表者（あなた）',
		shareHolderDetails: '株主{user} 情報:',
		continueNoShareholder: '株主なしで継続',
		infoSwitchOff:
			'追加書類が必要な場合は、バックオフィスの担当者からご連絡差し上げます。',
		fileNotValid:
			'正しいフォーマットとサイズのファイルをアップロードしてください。',
		resolUpload:
			'写真と文字が鮮明・明確であることを確認してください <br/><br/>現在お持ちの書類をアップロードしてください。全ての書類がお揃いでない場合もご安心ください。必要書類は後ほどアップロードや送信も可能です。',
		upDocument: '書類のアップロード',
	},

	expiredDocument: {
		resubmit: '書類を再提出する',
		settingsDesc:
			'本人確認書類、また、現住所確認書類を更新するには、こちらから再提出してください。',
		resubmitDesc:
			'お客様の認証書類の有効期限が切れています。今すぐ、または{days}日以内に会員ページの設定より新しいファイルをアップロードしてください。更新されるまで、入出金等の機能は無効されます。',
		idRefinitiv: 'のID認証方法を使用しますか？',
		idRefinitivDesc:
			'政府発行のIDで身元を更新することで、お客様のアカウントのセキュリティと正当性が確保されます',
		idTooltip:
			'ID認証を完了する方法を選択してください。スマートフォンでQRコードをスキャンするか、パソコンで新しいタブを開くことができます。以下からお好みの方法を選択してください。',
		cancelModal: '中断してよろしいですか？',
		cancelModalDesc:
			'このステップを{days}日以内に完了する必要がありますのでご注意ください。更新されるまで、キャビネットの引き出し、入金、送金機能にアクセスできません。',
		accessRestricted: 'アクセスが制限されました',
		uploadDocs: '書類をアップロードしてください',
		resubmitDocs: '書類を再提出する',
		restrictedID:
			'ランダムなチェック中に、提供されたIDが有効期限切れであることが確認されました。アカウントのセキュリティを確保するため、送金、引き出し、入金機能を一時的にブロックしました。',
		restrictedID2:
			'アクセスを復元し、キャビネットでシームレスな体験を続けるために、今すぐ新しいIDをアップロードしてください。',
		restrictedPOA:
			'ランダムなチェック中に、提出された住所証明書が有効期限切れであることが確認されました。アカウントのセキュリティを確保するため、送金、引き出し、入金機能を一時的にブロックしました。',
		restrictedPOA2:
			'アクセスを復元し、キャビネットでシームレスな体験を続けるために、今すぐ新しい住所証明書をアップロードしてください',
		restrictedBoth:
			'ランダムなチェック中に、提出されたIDと住所証明書の有効期限が切れていることが確認されました。アカウントのセキュリティを確保するため、送金、引き出し、入金機能を一時的にブロックしました。',
		restrictedBoth2:
			'アクセスを復元し、キャビネットでシームレスな体験を続けるために、今すぐ新しいファイルをアップロードしてください。',
		restrictedLimited:
			'必要書類の提出が完了しておりません。ライブ口座開設をご希望の場合は書類をアップロードしてください。',
		confirmationLimited:
			'このステップを完了しない場合、ライブ口座開設には至りませんのでご留意ください。',
		alertExpiredDocsSuccess:
			'ドキュメントを正常に提出しました。現在審査中です。追加の書類が必要な場合、当社チームよりご連絡いたします。',
		alertExpiredDocsError:
			'新しい書類を今すぐ、または {days} 日以内にアップロードしてください。',
		alertMissingDocsError:
			'口座の有効化にあたり、必要書類をごアップロードください。',
		submitDoc: '書類の送信',
		idverseD:
			'本人確認書類の認証は、詐欺を防止し、責任を持って合法的に弊社のサービスをご利用いただくために不可欠です。ご協力いただき、心から感謝申し上げます。',
		idverseT:
			'本人確認書類の提出方法を選択してください。スマートフォンでQRコードを読み取る、リンクをショートメールで受け取る、もしくはお手元のデバイスでプロセスを続行することが可能です。',
	},

	//Aplication Process refinitiv
	appliProcessIDverse: {
		QRdescription: 'スマートフォンのカメラでQRコードを読み取ってください',
		IDVerseTitle: 'どの本人確認方法を利用しますか？',
		IDVerseTitleLatam: 'ご希望の本人確認書類認証の方法を選択してください',
		IDVerseTitleManualDoc: 'ご希望の本人確認書類認証の方法を選択してください',
		IDVerseTitleManualDocTitle: '書類の種類を選択してください',
		IDVerseTitleManualDocDesc:
			'本人確認に使用したい書類の種類を選択してください：',
		IDVerseTitleManualDocMainDesc:
			'本人確認プロセスは、詐欺の防止、また適切な弊社のサービスをご利用いただくために不可欠です。ご協力をお願いいたします。',
		IDVerseDesc:
			'スムーズな認証のために、携帯電話を利用して、下記の方法より一つ選択していただくことをおすすめします。',
		or: 'お手元のデバイス上で書類をアップロードする場合は',
		verifyOnNewTab: '現在ご使用のディバイスでお進みください。',
		sendLinkSms: 'リンクをショートメールで受け取ってください',
		verifyPopupConfig:
			'ブラウザのポップアップブロッカーが無効になっていることを確認してください。詳細については。',
		clickHere: 'ここをクリック',
		alertDetail:
			'ご注意：認証プロセスには一度のみアクセス可能です。再度アクセスする必要がある場合は、ページを更新してからご希望の認証方法を選択してください。',
		alertDetailMobile:
			'ご注意：各ユニークリンクにつき、認証プロセスには一度のみアクセス可能です。認証を完了するには、ページを更新してから「IDを確認」を押してください。すでに完了している場合は、「続行」を押してください。',

		//Modal Verify Identity
		modalVerifyTitle: '本人確認を行ってください。',
		btnVerifyID: 'IDを確認',
		modalVerifyDesc1:
			'続行するには、本人確認プロセスを完了する必要があります。',
		modalVerifyDesc2:
			'すでに完了しているのに続行できない場合は、できるだけ早くお問い合わせください。',
		modalVerifyButton: '提出方法を選択してください',
		//Skip step
		modalSkipTitle: 'この手順をスキップしますか？',
		modalSkipDesc1:
			'このステップを一時的にスキップして、後で会員ページより完了するか、今すぐ書類の種類を選択して手続きを完了させることができます。',
		modalSkipDesc2:
			'取引アカウントの有効化には、このステップを完了することが必要ですのでご留意ください。',
		btnVerifyAddress: '住所を確認する',
		btnVerifyIdentity: '本人確認を行う',
		btnSkip: '今はスキップ',
		modalSendSMSChangeNumberTitle: '新しい携帯番号を入力してください',
		modalSendSMSChangeNumberDesc:
			'本人確認リンクをSMSで受け取りたい携帯番号を入力してください。',
		modalSendSMSChangeNumberButton: '送信',
		modalSendSMSChangeNumberCancel: 'キャンセル',
		modalSendSMSChangeNumberCheck: '登録済みの携帯番号として保存する',
		modalSendLinkSMSFailedTitle: 'エラーが発生しました',
		modalSendLinkSMSFailedDesc:
			'SMSでリンクを送信できませんでした。番号を確認してもう一度お試しください。',
		modalSendLinkSMSFailedButtonCancel: 'キャンセル',
		modalSendLinkSMSFailedButtonChangeNumber: '番号を変更する',
		modalSendLinkSMSTitle: 'SMSでリンクを送信しました',
		modalSendLinkSMSDesc:
			'登録済みの携帯番号にリンクをSMSで送信しました。携帯でリンクを開いて手順に従って本人確認を完了してください。',
		modalSendLinkSMSButtonReSend: '再送信',
		modalSendLinkSMSButtonOkay: 'OK',
		clickHere: 'こちら',
		or: 'お手元のデバイス上で書類をアップロードする場合は',
		modalSendLinkSMSOptionalNumber: '別の携帯番号に送信する',
		uploadCurrentDevice: 'からお願いします。',
		retryIn: 'もう一度お試しください：',
		chooseTooltip:
			'本人確認の方法を選択してください。スマホのカメラでQRコードをスキャンするか、SMSでリンクを送るか、現在のデバイスで続行できます。',
		sendToDifferentNumber: '別の携帯番号に送信する',
		chromeInstructions: {
			step1: '設定に移動します。',
			step2:
				'プライバシーとセキュリティ > サイトの設定 > ポップアップとリダイレクト に移動します。',
			step3: '「ブロック」オプションをオフにします。',
		},
		safariInstructions: {
			step1: 'Safari > 環境設定 に移動します。',
			step2: 'Webサイト > ポップアップウィンドウ を選択します。',
			step3: '必要に応じて設定を調整します。',
		},
		firefoxInstructions: {
			step1: 'メニューアイコンをクリックします。',
			step2: '環境設定 > プライバシーとセキュリティ > 権限 に移動します。',
			step3: '必要に応じてポップアップ設定を調整します',
		},
		assistanceText: `問題が発生した場合は、どうぞお気軽にお問い合わせください。`,
		assistanceText2: `サポートが必要な場合は、お問い合わせください。`,
	},

	//Application process CORPORATE form
	applicationFormCorporate: {
		liveCorporateAccount: 'ライヴ法人口座',

		//Company details
		companyDetailsTitle: '法人情報',
		nameLabel: '法人名',
		namePlaceholder: '半角英数で入力してください',
		businessTypeLabel: '事業の種類',
		businessTypePlaceholder: '事業の種類を選択してください',
		companyEmailLabel: 'メールアドレス',
		companyEmailPlaceholder: '会社のメールアドレスを入力してください',
		companyEmailTooltip:
			'法人口座情報の管理がスムーズに整うよう、法人口座専用のメールアドレスをご利用ください。',
		businessDescriptionLabel: '事業内容',
		businessDescriptionPlaceholder:
			'会社の規模やサービス内容を簡単にお知らせください',
		businessDescriptionTooltip:
			'こちらの情報をお知らせいただくことで貴社の活動と目的が明確となり、アカウントの承認プロセスがスムーズになります。',

		//Company address
		companyAddressTitle: '法人住所',
		companyAddressTitleTooltip: `法人の所在国を入力してください。地域における必要条件や規定に基づいたサービスを提供させていただくことが可能になります。
		お住まいの国が選択肢にない場合、サービスをご提供できません。`,

		//Account ownership
		accountOwnershipTitle: '法人に関する情報',
		dateIncorporationLabel: '設立日',
		dateIncorporationTooltip:
			'法人の設立日は、正式に登録されている年月日を入力してください。貴社の法的な登録状況の確認に必要な情報となります。',
		countryOfRegistrationLabel: '登録国',
		countryOfRegistrationPlaceholder: '国を選択',
		countryOfRegistrationTooltip:
			'法人の登録国を入力してください。この情報を入力していただくことにより、その地域における規定の確認をいたします。',
		marketCapitalizationLabel: '純資産・時価総額',
		marketCapitalizationPlaceholder: '半角数字で入力してください',
		marketCapitalizationTooltip:
			'純資産は資産総額から負債総額を差し引いた金額、時価総額は現在の株価に発行済株式数をかけた金額です。',
		isSubsidiaryLabel: '親会社の名称',
		isSubsidiaryPlaceholder: '半角英数で入力してください',
		isIndividualRegularMemberLabel:
			'口座申請は法人の代表者、または役員やパートナーにより行われていますか？',

		//Tax residency information
		taxResidencyTitle: '税務上の居住申告',
		isUSCompanyLabel: 'こちらの法人は米国での税務登録はありますか？',
		taxResidencyContryLabel: '法人は税務上、以下の国が所在国となります：',
		taxResidencyContryListLabel: '国',
		taxResidencyContryListPlaceholder: '国を選択',
		taxResidencyReferenceCodeLabel: '税納者番号',
		taxResidencyReferenceCodePlaceholder:
			'税納者番号（マイナンバー）をご記入ください',
		modalRegulationP:
			'規制により、米国領土に居住する方へのサービスは提供しておりません。',

		//Account type and platform information
		accountTypeTitle: '口座タイプ',

		// Financial details
		financialDetailsTitle: '財務内容',
		financialDetailsTooltip:
			'両当事者 (法人のお客様とトレードビュー) の適切なリスク管理のために経済状況の提示は必須となります。',
		companyAnnualIncomeLabel:
			'法人の年収もしくは年間の総売上高をお知らせください。',
		companyAnnualIncomeTooltip: '法人の年収または総売上高は1年の総収益です。',
		companyTotalAssetsLabel: '法人の総資産額をお知らせください',
		companyTotalAssetsTooltip:
			'総資産額は負債を差し引いた、貯金・投資・不動産の総額です。',
		companyLiquidAssetsLabel: '流動資産額をお知らせください',
		companyLiquidAssetsTooltip:
			'流動資産は現金貯金・マネーマーケット商品・市場性証券の総額を意味します',
		companyOriginAssetsLabel: '総資産の内容をお知らせください',
		companySourceFundsLabel: '資金の収入源をお知らせください',
		companyPruoseAccountLabel: '口座開設の目的',
		companyIsConnectedBanktruptcies: '法人の破産経験はございますか',
		companyIsConnectedBanktruptciesDetailsLabel: '破産の詳細をお知らせください',
		companyIsConnectedBanktruptciesDetailsPlaceholder:
			'詳細をご記入してください (日本語での回答可)',
		companyIsConnectedBanktruptciesDetailsTooltip:
			'会社は、両当事者（会社およびTradeview）のリスクに対処するために、破産に関連するすべての情報を開示する必要があります。しかし、会社が破産に関連する関係を持っている場合でも、申請プロセスを進めることができることをご安心ください。',

		//Proof of address
		proofAddressTitle: '現住所確認書類のご提出',
		proofAddressTitleCorporate: '法人の現住所確認書類',
		proofAddressDescription:
			'規制基準が満たされているか確認するため、現住所確認書類をご提出ください。',

		//Company Account Consent
		companyAccountConsentTitle:
			'法人情報をご入力いただきありがとうございました',
		companyAccountConsentDescription1:
			'次に、役員の方に関する情報をご入力してください。既にご入力、アップロードいただいた項目で修正したい個所がある場合、スクリーン右側の鉛筆マークをクリックいただくことで、正しい情報をご入力いただけます。',
		companyAccountConsentDescription2:
			'顔写真付き本人確認書類と現住所確認書類以外の必要書類は、後ほどアップロードや送信も可能です。',
		companyAccountConsentDocumentsTitle: '下記の書類が必要となります',
		companyAccountConsentDocumentsList1: '代表者の顔写真付き本人確認書類',
		companyAccountConsentDocumentsList2: '代表者の現住所確認書類',
		applicationFormAccountCheck:
			'*私はTradeview Financial Markets S.A.C. が本人確認書類を含む個人情報に対し電子的な本人確認を行うことに同意します。その際、情報はその正確性を確認するために信頼性の高い本人確認サービスプロバイダーと共有され、同社のデータや他の信頼性の高い情報源から取得したデータと照合されるのを承認します。',

		//Company Consent
		companyConsentTitle:
			'口座開設をご希望いただきありがとうございます。<br> これより申請へとお進みください',
		companyConsentDescription:
			'法人口座開設のために、下記の書類が必要となります。',
		companyConsentDocumentsTitle: '事前に以下の書類をご用意ください',
		companyConsentDocumentsOfCompanyTitle: '法人口座必要書類',
		companyConsentDocumentsList1: '会社登記証明書',
		companyConsentDocumentsList2: '会社の住所証明',
		companyConsentDocumentsList3: '会社の銀行取引明細書',
		companyConsentDocumentsList4: 'Corporate Resolutions (取締役会決議書)',
		companyConsentDocumentsList5: '',
		companyConsentDocumentsList6: '会社の所有構造',
		companyConsentDocumentsList7: '',
		companyConsentDocumentsOfAccountHolderTitle: '',
		companyConsentDocumentsOfAccountHolderList1: '',
		companyConsentDocumentsOfAccountHolderList2: '',
		companyConsentDocumentsOfShareholderTitle: '代表者・役員の方の必要書類',
		companyConsentDocumentsOfShareholderList1: '本人確認書類',
		companyConsentDocumentsOfShareholderList2: '現住所確認書類',
		companyConsentAdditionalInfoDescription:
			'必要書類は後ほどアップロードや送信も可能です',
		applicationFormConsentCheck:
			'*私はTradeview Financial Markets S.A.C. が本人確認書類を含む個人情報に対し電子的な本人確認を行うことに同意します。その際、情報はその正確性を確認するために信頼性の高い本人確認サービスプロバイダーと共有され、同社のデータや他の信頼性の高い情報源から取得したデータと照合されるのを承認します。',

		//Account holder details
		accountHolderDetailsTitle: '代表者に関する情報',
		accountHolderDetailsTooltip:
			'代表者はトレード判断や入出金など、業務執行や法人を代表した契約締結などの権限をもつ役員です。',

		//Account holder address
		accountHolderAddressTitle: '代表者の住所',
		accountHolderAddressTooltip:
			'こちらは法人の登録住所ではなく、代表者の事務所や住居の現住所情報を入力してください。',

		//Account holder tax residency declaration
		accountHolderTaxResidencyTooltip:
			'こちらは法人ではなく代表者の方の情報を入力してください。',
		accountHolderTaxResidencyModalDescription:
			'申し訳ございませんが、規制により、',

		//Account holder trading experience
		accountHolderTradingExperienceDescription:
			'外国為替、株式、先物、デリバティブ、またはCFDの取引経験を最もよく表している項目を選択してください。',

		//Shareholder consent
		shareholderConsentTitle: '代表者の情報登録が完了しました',
		shareholderConsentDescription1:
			'以前に指定した詳細は、画面の右側にある進行状況リストを使用していつでも編集できます。編集したい情報の横にある鉛筆アイコンをクリックするだけです',
		shareholderConsentDescription2:
			'役員の方がいらっしゃる場合、役員の方の情報、身分証明書、現住所確認書類のみとなります。',
		shareholderConsentDescription3:
			'必要書類は後ほどアップロードや送信も可能です。',
		companyConsentConsentDocumentsTitle:
			'株主様の情報入力にあたり、以下の書類提出が必要となります。',
		companyConsentConsentDescription1:
			'引き続き株主様の情報登録へとお進みください。',
		companyConsentConsentDescription2:
			'既にご入力された情報の訂正が必要な場合は、スクリーン右側の鉛筆マークをクリックし、修正してください。',
		shareholderConsentDocumentsTitle: '下記の書類が必要となります',
		shareholderConsentDocumentsList1: '株主様の本人確認書類',
		shareholderConsentDocumentsList2: '役員様の現住所確認書類',
		shareholderConsentDocumentsList3: '電子署名',
		shareholderConsentCheck:
			'*私はTradeview Financial Markets S.A.C. が本人確認書類を含む個人情報に対し電子的な本人確認を行うことに同意します。その際、情報はその正確性を確認するために信頼性の高い本人確認サービスプロバイダーと共有され、同社のデータや他の信頼性の高い情報源から取得したデータと照合されるのを承認します。',

		//Application Submition
		applicationSubmitionTitle: '申請書の提出',
		applicationSubmitionDescription1:
			'ご準備ができましたら下記の送信ボタンをクリックしてください。ご不明な点がございましたら japanesesupport@tvmarkets.com へご連絡下さい。',

		applicationSubmitedTitle: '法人口座の申請提出が完了しました。',
		applicationSubmitedDescription1:
			'法人口座申請をご提出いただきありがとうございます。これより順次審査へと進ませていただきます。',
		applicationSubmitedDescription2:
			'こちらの情報記入時に請求された書類のアップロードを済まされてない場合、また、書類に不備があった場合等、弊社のオペレーションチームがご連絡いたします。',
		//Global
		selectOption: 'トレード期間',
		accountOwnershipTooltip:
			'これは、あなたのビジネスが主に所在する国を指します。正確な情報は、地域の要件や規制に基づいてサービスをカスタマイズするのに役立ちます。もし、あなたの所在国が選択肢にない場合、残念ながらその場所では弊社のサービスを提供することができません。',

		//Progress
		companyInformation: 'ご登録情報',
		companyAddressDetails: '会社住所詳細',
		companyOwnershipDetails: '会社の所有権の詳細',
		companyDocuments: '法人書類のご提出',
		accountConsent: 'アカウントの同意',
		accountConsentCorporate: '代表者様の情報',
		tradingExperience: 'トレード経験',
		accountInformation: '口座情報',
		tradingExperience: 'トレード経験',
		IDVerification: '身分証明書の確認',
		accSetupSubmision: 'アカウントの設定と提出',
		shareholderInformation: '役員に関する情報',
		shareholderConsent: '株主の同意',
		finish: '仕上げる',
		addressDetails: '住所の詳細',
		share: '保有株',

		//Shareholder consent
		welcomeShareholderConsentTitle:
			'法人アカウントに参加する準備はできましたか？申請を始めましょう',
		welcomeShareholderConsentDescription1:
			'法人アカウントを設定するために、いくつかの情報が必要です。',
		shareholderConsentDocumentsTitle:
			'開始する前に、以下の書類を準備してください：',
		welcomeShareholderConsentDocumentsList1: '政府発行の写真付きID',
		welcomeShareholderConsentDocumentsList2: '住所証明書',
	},

	//disclaimer
	disclaimer: {
		title: '免責事項',
		secure1: '安全な',
		secure2: 'SSL暗号化',
		secure3: '',
		jp: {
			description:
				'Tradeview Financial Markets S.A.C. が提供するサービスおよび商品は、米国（US）内で提供されるものではなく、米国法に基づき定義されるUS Personsに提供されるものではありません。本ウェブサイトの情報は、FXおよび/またはCFD取引が現地の法律または規制により制限または禁止されている国の居住者に向けたものではありません。CFDは複雑な金融商品であり、レバレッジにより急速に資金を失う高いリスクを伴います。個人投資家の口座の74％～89％がCFD取引で損失を出しています。CFDの仕組みを理解し、資金を失う高いリスクを負う余裕があるかどうかを検討する必要があります。',
		},
		term: '利用規約',
		privacy: 'プライバシーポリシー／個人情報管理方針',
		aml: 'AMLポリシー／マネーロンダリング対策方針',
		withdrawal: '出金ポリシー／出金方針',
		refund: '返金ポリシー／返金方針',
		risk: 'リスク開示',
		default: {
			description:
				'Tradeview Markets が提供するサービスおよび製品は、米国 (US) 内では提供されておらず、米国法の定義に基づく米国人には提供されていません。このウェブサイト上の情報は、FX および/または CFD の取引が現地の法律や規制によって制限または禁止されている国の居住者を対象としたものではありません。CFD は複雑な金融商品であり、レバレッジによって急速に資金を失うリスクが高いです。CFD 取引では、小売投資家の口座の 74% ～ 89% が損失を出しています。CFD の仕組みを理解しているか、資金を失う高いリスクを取る余裕があるかどうかを検討する必要があります。',
		},
		ltd: {
			description:
				'Tradeview Ltd. が提供するサービスおよび製品は、米国 (US) 内では提供されておらず、米国法の定義に基づく米国人には提供されていません。このウェブサイト上の情報は、FX および/または CFD の取引が現地の法律や規制によって制限または禁止されている国の居住者を対象としたものではありません。CFD は複雑な金融商品であり、レバレッジによって急速に資金を失うリスクが高いです。CFD 取引では、小売投資家の口座の 74% ～ 89% が損失を出しています。CFD の仕組みを理解しているか、資金を失う高いリスクを取る余裕があるかどうかを検討する必要があります。',
		},
		latam: {
			description:
				'Tradeview Financial Markets S.A.C. が提供するサービスおよび製品は、米国 (US) 内では提供されておらず、米国法の定義に基づく米国人には提供されていません。このウェブサイト上の情報は、FX および/または CFD の取引が現地の法律や規制によって制限または禁止されている国の居住者を対象としたものではありません。CFD は複雑な金融商品であり、レバレッジによって急速に資金を失うリスクが高いです。CFD 取引では、小売投資家の口座の 74% ～ 89% が損失を出しています。CFD の仕組みを理解しているか、資金を失う高いリスクを取る余裕があるかどうかを検討する必要があります。',
		},
		mena: {
			description:
				'Tradeview Financial Markets S.A.C. が提供するサービスおよび製品は、米国 (US) 内では提供されておらず、米国法の定義に基づく米国人には提供されていません。このウェブサイト上の情報は、FX および/または CFD の取引が現地の法律や規制によって制限または禁止されている国の居住者を対象としたものではありません。CFD は複雑な金融商品であり、レバレッジによって急速に資金を失うリスクが高いです。CFD 取引では、小売投資家の口座の 74% ～ 89% が損失を出しています。CFD の仕組みを理解しているか、資金を失う高いリスクを取る余裕があるかどうかを検討する必要があります。',
		},
	},

	//modal
	modal: {
		error: '申請を続けることができません。',
		description: '申し訳ございませんが、規制により、。',
		thank: '規制により、米国領土に居住する方へのサービスは提供しておりません。',
		btnRegulation: '規制ページに移動',
	},

	//tooltips
	tooltips: {
		signature1:
			'どのように電子署名を提出されたいかご選択ください。署名の画像をアップロードしていただくか、電子署名システムを利用して、画面上に直接ご署名頂くことが可能です。いずれの方法がご希望か、以下でご選択ください。',
		sourceAccount: '',
		sourceAccountTransfer: '',
		withdrawCurrency:
			'「通貨」は取引口座の主要通貨を指します。以下の略語で表示されます： <br><br> USD: アメリカドル <br> EUR: ユーロ <br> GBP: イギリスポンド',
		currencyUSD: 'USD: アメリカドル',
		currencyEUR: 'EUR: ユーロ',
		currencyJYP: 'JPY: 日本円',
		currencyCAD: 'CAD: カナダドル',
		currencyGBP: 'GBP: イギリスポンド',
		targetAccount: '',
		digitalWallets:
			'電子ウォレットに関しましては、様々な種類のウォレットの使用が可能です。入金方法によって手数料が発生することもございますのでご了承ください。',
		wireTransfers:
			'国内送金をご希望の場合は、<br> サポートにお問い合わせ <br> ください。 ',
		cardTransfers:
			'カードの入金はVisa、Mastercard、およびApple Payでのお支払いが可能です。Apple Payでの入金をご希望の場合はサポートへご連絡ください。',
		currencyUphold: `「通貨」は取引口座の主要通貨を指します。以下の略語で表示されます：
<br/>USD: アメリカドル <br/>EUR: ユーロ <br/>JPY: 日本円 <br/>CAD: カナダドル <br/>AUD: オーストラリアドル <br/>CHF: スイスフラン <br/>GBP: イギリスポンド
 <br/>MXN: メキシコペソ<br/>ZAR: 南アフリカランド`,
		currencyType: '通貨は、アカウントで使用する主なお支払い方法です。',
		leverageTM:
			'レバレッジを利用すると小額の証拠金で大きな取引が可能になります。50倍、100倍等のレバレッジを使うことでお持ちの資金に対しより大きな取引ができます。',
		demoXleverage: 'X-Leverage: 1:400',
		demoILC: 'ILC: 1:200',
		demoStock: 'Stock: 1:1',
		notSureAccount:
			'どのアカウントの種類を選択すればよいかわからない場合は、レビューすることができます',
		japan: {
			withdrawCurrency: '移動元の口座通貨をお選びください',
		},
	},

	//register
	register: {
		goBack: '戻る',
		titleRegister: 'アカウント登録',
		AccountDesc:
			'トレードビューのポータルへようこそ！デモアカウント、またはライブアカウントを選択し、弊社ならではのトレーディング環境をお楽しみください。',
		AccountChoose: 'どのタイプのアカウントを作成しますか？',
		dinamicDescLive:
			'まだライブアカウントを開設する準備ができていませんか？ <br><spam>デモアカウントを作成する</spam>',
		dinamicDescDemo:
			'ライブ口座開設をご希望ですか？<spam>ライブアカウントを作成する</spam>',

		getYour: '口座を開設する',
		or: 'メールアドレスでログイン：',
		email: 'メールアドレス',
		secure: 'パスワード',
		confirmPassword: 'パスワードの確認',
		disclaimer:
			"Disclaimer: Before opening an account it is our obligation at Tradeview Financial Markets S.A.C. ('Tradeview') to ensure that You or the person/s appointed to trade on your behalf have the necessary knowledge and experience in CFD and related financial instruments. It is also our requirement to comply with AML and CFT obligations. In this regard you are kindly requested to provide accurate, complete and factual information as requested in line with this application and in order for us to complete compliance with the above obligations. On the basis of this information we are able to properly determine whether the investment services in connection with the financial instrument/s is/are appropriate to You. All Sections need to be completed. For further details please refer to our Client Agreement. For EU clients: By checking the box below, you are confirming that you have not been solicited by Tradeview or by any individual associated with Tradeview to open an account with the selected entity. ",
		byTicking: 'ボックスにチェックをし、利用規則に同意してください',
		getstarted: '次へ',
		messageFooter1: ' が提供するサ ',
		messageFooter2:
			'ービスおよび商品は、米国（US）内で提供されるものではなく、米国法に基づき定義されるUS Personsに提供されるものではありません。本ウェブサイトの情報は、FXおよび/またはCFD取引が現地の法律または規制により制限または禁止されている国の居住者に向けたものではありません。CFDは複雑な金融商品であり、レバレッジにより急速に資金を失う高いリスクを伴います。個人投資家の口座の74％～89％がCFD取引で損失を出しています。CFDの仕組みを理解し、資金を失う高いリスクを負う余裕があるかどうかを検討する必要があります。',
		client: 'クライアントキャビネット',
		instructionstitle1: '世界最高基準の',
		instructionstitle2: 'トレード環境と',
		instructionstitle3: 'テクノロジー',
		options1f: '会員ページ',
		options1l: '',
		options2f: 'IBポータル',
		options2l: '',
		options3f: 'Propレポート',
		options3l: '',
		haveAccount: '',
		signUp: 'ログイン',
		newCode: 'コードを以下のメールアドレスへ送信しました',
		tryEgain: 'コードが送信できません。再度お試しください。',
		invalidEmail: '正しいフォーマットではありません。訂正してください。',
		passwordRequired: 'こちらは必須項目です。必ずご記入ください。',
		invalidPassword:
			'パスワードは8文字以上で、少なくとも1つの小文字、1つの大文字、1つの数字、および1つの特殊文字を含める必要があります',
		confirmPasswordRequired: 'こちらは必須項目です。必ずご記入ください。',
		passwordsDoNotMatch: 'パスワードを間違えています。再度ご入力してください。',
		errorDisclaimer: 'ボックスにチェックをし、利用規則に同意してください',
		firstNameError: 'こちらは必須項目です。必ずご記入ください。',
		typeAccountError: 'アカウントの種類を選択してください',
		invalidName:
			'お名前には、アラビア数字や記号をご記入いただけません。再度ご記入ください。',
		invalidLastName: 'お名前を半角ローマ字でご入力してください',
		mfaCode: 'MFAコードを入力してください',
		startDemo: '無料デモ口座を開設する',
		orRegister: 'メールアドレスでログイン：',
		verificationCode: '認証コード',
		didntCode: 'コードが届きませんか?',
		yourEmail: 'メールアドレス',
		firstName: '名（ローマ字）',
		lastName: '姓（ローマ字）',
		accountType: '口座タイプ',
		accountCategory: '口座種類',
		accountCategoryPlaceholder: '選択してください',
		accountCategoryTooltip: `<strong>個人口座:</strong>  
</br> このオプションを選択してください。
あなたが単一の口座保有者の場合。</br></br> <strong>共同口座:</strong>  </br> 配偶者やビジネスパートナーなど、他の誰かと一緒に口座を開設する場合は、このオプションを選択してください。 </br></br> <strong>法人口座:
</strong> </br>ビジネスや組織などの法人を代表している場合は、このオプションを選択してください。 `,
		entity: '選択してください',
		entityPLaceholder: '事業体を選択してください',
		entityTooltip:
			'私たちは、運営するすべての管轄区域で厳格な財務基準を遵守しています。詳細はこちらをご覧ください。',
		countryTooltip:
			'お客様の居住国がこちらのリストにない場合、誠に恐れ入りますが弊社にてこちらのサービスは提供出来かねてしまいます。',
		accountRegis: '口座を開設する',
		checkRegis:
			'このボックスにチェックを入れることにより、私は、TradeviewまたはTradeviewに関連する個人から事業体の切り替えを求められていないことを認めます。',
		changeRegion: '自分のリージョンのエンティティへの変更',
		liveIndividual: 'ライブ個人アカウント </br> 今すぐ取引を開始！',
		jointIndividual: 'ライブ共同アカウント </br> 今すぐ取引を開始！',
		corporateIndividual: 'ライブ法人アカウント </br> 今すぐ取引を開始！',
		entityText:
			'選択した居住国とは異なる地域で設立され、規制されているアカウント作成の事業体を選択しようとしています。',
		entity: '選択してください:',
		entityPLaceholder: '事業体を選択してください',

		entityTextEu: `現在アクセスしているウェブサイトは、欧州連合に設立されていない、またはEUの国家所轄官庁によって規制されていない事業体によって運営されています。  <br><br> 「続行」をクリックすることにより、TradeviewまたはTradeviewに関連する個人から事業体の切り替えを勧誘されていないことを確認したことになります。 <br><br> 欧州連合(EU)の規制対象事業体であるTradeview Europe Ltd.に誘導するには、「地域の事業体に変更」をクリックしてください。Tradeview Europe Ltd.は、お客様の管轄区域に適したMFSAによって規制されています。`,
		entitiesTitle: '弊社のブランドで取引する国際的な事業体:',
		entitiesDesc: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>ケイマン諸島金融庁（CIMA）によって規制され、ケイマン諸島の法律(SIBL)に基づいて運営されています。</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (ペルー、日本、MENA)</b> </li> </ul> <p>SUNARPに登録されており、ペルーの一般会社法（LGS）に基づいて運営されています。</p> <br> <ul> <li> <b>Tradeview Europe Ltd.</b> </li> </ul> <p>マルタ金融サービス庁（MFSA）によって規制されており、EBA、ESMA、IOSCOのメンバーです。</p>`,
		entitiesDescEu: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>ケイマン諸島金融庁 (CIMA) によって規制され、ケイマン諸島の法律 (SIBL) のもとで運営されています。</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (ペルー、日本、中東・北アフリカ地域)</b> </li> </ul> <p>SUNARP に登録され、ペルーの会社一般法 (LGS) に基づいて運営されています。</p>`,
		individual: '個人',
		joint: 'ジョイント',
		corporate: '企業向け',
		reloadPage: 'ページを更新することでデータ入力を妨げる問題が解決されます。',
		instructionsIB1: 'ブローカーとして成長する',
		instructionsIB2: 'IBになる',
		instructionsIB3: '5分以内に',
		titleIbRegister: 'Tradeview Marketsが初めてですか？',
		disclaimerIBportal:
			'免責事項：口座開設に先立ち、Tradeview Financial Markets S.A.C.（Tradeview）は、お客様またはお客様に代わって取引を行うよう任命された人物が、CFDおよび関連金融商品に関して必要な知識と経験を有していることを確認する義務があります。また、AMLおよびCFTの義務を遵守することも当社の要求事項です。この観点から、お客様は、本申込書に沿って、また当社が上記の義務を遵守するために、正確、完全かつ事実に基づいた情報をご提供ください。この情報に基づいて、金融商品に関連する投資サービスがお客様にとって適切かどうかを適切に判断することができます。すべてのセクションにご記入いただく必要があります。詳細については、当社の顧客契約をご参照ください。',
		alreadyClient: 'すでにTradeviewをご利用のお客様',
		loginClientCabinet: ' クライアント・キャビネットにログインする',
		registerIB: 'IBとして登録する。',
		instructionsIBportal1: '私たちがカバーします！',
		instructionsIBportal2: 'あらゆるニーズに ',
		instructionsIBportal3: 'ソリューション',
		options1f_ib_portal: 'ソリューション',
		options1l_ib_portal: 'インテグラル',
		options2f_ib_portal: 'カスタマーサポート',
		options2l_ib_portal: '年中無休',
		options3f_ib_portal: 'リベートの日次支払い',
		options3l_ib_portal: 'コミッション',
		register_enjoy: '今すぐ登録して楽しもう：',
		fast_onboarding: '迅速なオンボーディング ',
		no_program: '初期費用無料プログラム',
		fast_solutions: 'ターンキー・クライアント・ソリューション',
	},

	'reset-password': {
		instructionstitle1: '世界最高基準の',
		instructionstitle2: 'トレード環境と',
		instructionstitle3: 'テクノロジー',
		title: '新しいパスワードを設定する',
		label1: '新しいパスワード',
		label2: 'パスワードの確認',
		options1f: '会員ページ',
		options1l: '',
		options2f: 'IBポータル',
		options2l: '',
		options3f: 'Propレポート',
		options3l: '',
	},

	//Calendar
	calendar: {
		title: 'カレンダー',
	},

	//application process
	application: {
		optional: '(オプション)',
		ifApplicable: '(該当する場合)',
		jobTitleL: '職位名',
		jobTitleP: 'あなたの職位名を入力してください',
		emplymentAditionalDetails: '追加情報',
		taxResTitle: '税務上の居住申告',
		taxResPurposes: '税務上の米国市民または米国居住者ですか？',
		taxLabelCompany:
			'会社は、税務上、以下の国の居住者であることをここに確認します:',
		taxLabelIndividual:
			'私は、税務上、以下の国の居住者であることをここに確認します:',
		taxResHereby: '私は税務上、以下の国の居住者です：',
		taxResCountryL: '国',
		taxResCountryP: '国を選択',
		taxResMarketL: '税納者番号',
		jobTitleL: '職位',
		jobTitleP: '職位を入力してください',
		taxResMarketP: '税納者番号（マイナンバー）をご記入ください',
		taxResMarketTM:
			'税納者番号は数字のみ、または英数字のコードです。日本在住のお客様の場合はマイナンバーが税納者番号に該当します。',
		taxResPoliticalL: 'あなたはPEPs、またはその近親者ですか。',
		taxResPoliticalTM:
			'PEP（Politically Exposed Person）とは、著名な公職に就いている、または就いていた人物のことで、財務上のリスク評価に影響を与える可能性があります。',
		taxResStatusL: 'あなたのPEPの地位またはPEPとどのような関係がありますか？',
		taxResStatusP: 'あなたのPEPの地位または関係を詳しく教えてください。',
		taxResStatusTM:
			'両者（お客様とTradeview）のリスクに適切に対処するため、お客様のPEPステータスまたは関連する人脈を開示することが義務付けられています。しかしながら、お客様がPEPである場合、またはPEPと何らかの関係がある場合でも、ご安心してお申し込み手続きを進めてください。',
		taxCode: '税務参照コード',
		taxCodeTooltip: `あなたの税務参照コードは、文字と数字の組み合わせで構成されている場合や、完全に数字である場合があります。あなたの情報は安全に保護されています。OECDの報告基準に従い、この情報を収集する必要があります。詳しくは <a href="https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/" target="_blank" rel="noopener noreferrer">こちら</a> をご覧ください。`,
		selectTaxCode: '税務参照コードを入力してください',
		accountTypeH: '口座タイプ',
		accountTypeD:
			'一度口座開設していただきますと、次回よりフォームへのご記入は必要なく、追加口座をご希望の取引設定に合わせて開設申請していただけます。',
		tradingMarketL: '取引市場',
		tradingMarketP: '選択してください',
		tradingMarketTM:
			'取引市場とは、資産や金融商品が取引される市場または取引所のことです。 <br><br> こちらで取引市場を選択してください。',
		currencyTypeL: '口座通貨',
		currencyTypeP: '口座通貨の選択',
		currencyTypeTM: '「通貨」とは、口座で使用する主要な支払い形式です。',
		platformL: 'プラットフォーム',
		platformP: 'プラットフォームを選択してください',
		platformTM:
			'「プラットフォーム」とは、資産や金融商品を操作するために提供されるソフトウェアシステムです。<br><br> こちらでプラットフォームを選択ください。',
		accountTypeL: '口座タイプ',
		accountTypeP: 'ご希望の口座タイプを選択してください',
		accountTypeTM:
			'「口座タイプ」により適応可能レバレッジが異なります。<br><br>X-レバレッジ：1:500 <br> iLC：1:200 <br> 株式：1:3  <br><br> こちらで口座タイプを選択してください。',
		emplymentDetailsH: '雇用に関する詳細',
		employmentStatusL: '雇用状況',
		employmentStatusP: '雇用状況を選択してください',
		employerL: '雇用主',
		employerP: '雇用主の名前を入力してください',
		occupationL: '職業',
		occupationP: '職業を入力してください',
		industryL: '業界',
		industryP: '事業に関してお答えください',
		industryTM: '所属する会社の基本的な特性と業務内容に関して',
		employmentTypeL: '雇用形態',
		employmentTypeP: '雇用の性質を選択してください',
		employmentTypeTM: '勤務形態や雇用状況を定義する基本的な特性や条件に関して',
		employmentAddressL: '雇用主の住所',
		employmentAddressP: '雇用先の住所を入力してください',
		employerCountryL: '雇用主の国',
		employerCountryP: '国を選択',
		employerProvinceL: '雇用主の都道府県',
		employerProvinceP: '都道府県',
		employerCityL: '雇用主の市区町村',
		employerCityP: '市区町村を入力してください',
		employerZipL: '雇用主の郵便番号',
		employerZipP: '雇用主の郵便番号を入力してください',
		businessTypeL: '事業の種類',
		businessTypeP: '事業の種類を選択してください',
		businessTypeTM:
			'事業の種類は、企業がビジネスを行う際に採用するさまざまな法的構造や形態を指します。',
		businessCountryL: '事業の国',
		businessCountryP: '国を選択',
		businessProvinceL: '事業の都道府県',
		businessProvinceP: '都道府県',
		businessCityL: '事業の市区町村',
		businessCityP: '市区町村を入力してください',
		businessLocationL: '事業の所在地',
		businessLocationP: '事業の住所を入力してください',
		businessNameL: '事業名e',
		businessNameP: '事業名を入力してください',
		businessWebL: '事業のウェブサイト',
		businessWebP: '事業のウェブサイトURLを入力してくださいl',
		businessIndustryL: '業界',
		businessIndustryP: '事業に関してお答えください',
		businessIndustryTM: '所属する会社の基本的な特性と業務内容に関して',
		financialDetailsH: '経済状況の詳細',
		annualIncomeL: '年収もしくは年間の総売上高を教えてください',
		totalAssetsL: '総資産額を教えてください',
		totalAssetsTM:
			'総資産額は、コミットメント手数料を差し引いた、貯金・投資・不動産の総額を意味します。',
		liquidAssetsL: '流動資産額を教えてください',
		liquidAssetsTM:
			'流動資産は現金貯金・マネーマーケット商品・市場性証券の総額を意味します',
		tradeAnnuallyL: '年間の投資予定額を教えてください',
		originAssetsL: '総資産の内容を教えてください',
		originDepositsL: '資金の収入源を教えてください',
		purposeAccountL: '口座開設の目的',
		bankruptciesDetailsL: '破産の詳細をお知らせください',
		bankruptciesDetailsP: '詳細をご記入くださいh',
		bankruptciesDetailsTM:
			'両当事者（顧客とトレードビュー）のリスク管理を適切に行うため、破産詳細の提示は必須となっています。 <br><br> ただし、破産経験があった場合も口座開設は可能ですのでご安心ください。',
		bankruptciesConnetL: '破産された経験はございますか',
		tradingExperienceH: '投資のご経験',
		tradingExperienceD:
			'外国為替、株式、先物、デリバティブ、またはCFDの取引経験を最もよく表しているオプションを選択してください。',
		tradingExperienceDMENA:
			'外国為替、株式、デリバティブ、またはCFDの取引経験を最もよく表すオプションを選択してください。',
		tradingExperienceTM:
			'お客様の取引経験についてお伺いすることで、個別サポート、ガイダンス、および最適な取引体験を提供するお手伝いをいたします。経験豊富なトレーダーでも、これから始める方でもご利用いただけます。',
		yearsTradingL: '取引経験は何年ですか？',
		yearsTradingP: 'トレード期間',
		tradingVolumenL: '取引額はどれくらいですか？',
		tradingVolumenP: 'トレード期間',
		oftenTradeL: 'どのくらいの頻度で取引しますか？',
		oftenTradeP: 'トレード期間',
		identityH: '本人確認書類のご提出',
		identityDesc: '認証を完了するには、次のいずれかの書類が必要です：',
		identityD:
			'政府発行の本人確認書類を確認することで、お客様の口座の安全性と合法性を保証します。',
		identityDLatam:
			'よりスムーズにお進みいただくため、以下のQRコードをお手持ちのスマートフォンでスキャンし、このステップを完了することをお勧めします。認証を行うには、以下のいずれかの書類が必要です。',
		idDocumentL: '身分証明書',
		idDocumentP: '書類の種類を選択してください',
		idDocumentTM:
			'本人確認書類の種類は、弊社のコンプライアンス規定に基づき、以下より一点必要となります： <br> <br> パスポート（推奨）<br> 在留カード<br> マイナンバーカード<br> 運転免許証、在留カード',
		idDocumentUploadL: '書類のアップロード ',
		idDocumentUploadTM: '写真と文字が鮮明・明確であることを確認してください。',
		idDocumentFrontL: '前面',
		idDocumentFrontTM: '前面には顔写真、氏名、ID番号が表示されています。',
		idDocumentBackL: '裏面',
		idDocumentBackTM:
			'裏面には、住所やその他の関連情報などの追加情報が記載されています。',
		proofResidenceH: '現住所確認書類',
		proofResidenceHYour: 'あなたの居住証明',
		proofResidenceD:
			'現住所確認書類をご提出ください。**3か月以内に発行された書類のみ有効です。',
		proofResidenceL: '現住所確認書類',
		proofResidenceP: '書類の種類をご選択ください',
		proofResidenceTM:
			'お住まいのご住所を確認するため、ご住所が市区町村名から記載されており、3か月以内の発行日が記載されているご本人様名義の書類を、下記より1点ご提出下さい。書類は必要箇所だけでなく全体が確認できるものが必要となります。<br><br>  • 公共料金等の請求書 <br>  • 銀行取引明細書 <br> • 住民票 <br> •印鑑証明 <br><br>   受付可能な請求書:    <br>• ガス    <br>• 電気  <br>  • 電話  <br>  • インターネット（お住まいのご住所でご利用の場合のみ可）  <br>  • ケーブル（お住まいのご住所でご利用の場合のみ可）  <br>  • 銀行取引明細、又はクレジットカード請求書 <br><br> 個人番号カード（通知カード）、運転免許証、通知書などは現住所確認書類として受諾出来かねます。',
		proofUploadL: '書類のアップロード',
		proofUploadTM:
			'以下の点について、必ずご確認ください。 <br><br> • 3 か月以内の発行日（又はご利用月）が記載されていること。 <br>• ご本人様名義の書類であること。 <br>• 申請書にご記入いただいたご住所と同じご住所が記載されていること。 <br>• 書類の四隅が全てお写真に納まっていること。',
		addressDetail: '住所',
		financialDetailsTM:
			'両当事者（顧客とトレードビュー）のリスク管理を適切に行うため、経済状況の提示は必須となっています',
		acknowledgementH: '確認',
		acknowledgementCheck:
			'上記の各ドキュメントに記載されている全ての情報を読み、理解した上で同意します。',
		signatureH: '署名',
		signatureP1:
			'下記に電子署名することで、これまでの申請の過程の全てのドキュメントに記載されている全ての情報について認め、同意いたします。',
		signatureP2:
			'また、本申請書に記された全ての情報が事実かつ正確であることを認め、虚偽の申請をした場合は偽証罪によって罰せられることを理解しているとともに、開設された私本人名義の口座へ入金される資金は、資金源、通貨、入金方法に拘らず、犯罪や違法行為によって得た利益ではなく、正当な資金であることを認めます。',
		signatureMethod: 'どのように電子署名を提出されますか？',
		signatureDraw: '署名',
		signatureUpload: '署名のアップロード',
		signatureTM:
			'どのように電子署名を提出されたいかご選択ください。署名の画像をアップロードしていただくか、電子署名システムを利用して、画面上に直接ご署名頂くことが可能です。いずれの方法がご希望か、以下でご選択ください。',
		signatureAD: 'クライアントの署名、上記よりご署名ください。',
		additionalRiskH: '追加リスク同意書',
		additionalRiskD1:
			'申請書にご記入いただきました情報によりますと、お客様は以下のいずれか（または複数）の条件に該当し、トレードビュー Ltd. の口座開設のためのガイドラインを満たしておりません。',
		additionalRiskP1Latam:
			'Tradeview Markets クライアントアカウント契約に含まれる業界標準の開示に加え、外国為替取引はリスクの高い投資と見なされていることを認識しておくべきです。これまでに保守的な投資だけを行ってきた場合、この種の投資を続ける前に、外国為替取引についてさらに詳しく学んでおくことをお勧めします。',
		additionalRiskP2Latam:
			'投資を続けることを希望する場合、あなたはコミットした資金が純粋にリスク資本であり、投資の損失があなたの生活スタイルを脅かすことはないし、将来の退職プログラムにも影響しないことを認めます。さらに、外国為替投資の性質とリスクを完全に理解しており、投資損失が発生した場合でも他者への義務が怠られることはないことを理解しています。',
		additionalRiskUl1: '年齢が２１歳から６３歳の間ではない。',
		additionalRiskUl2: '年収が２５０万円未満である。',
		additionalRiskUl3: '過去１年以内に自己破産の経験がある。',
		additionalRiskUl4: '現在就職していない。',
		additionalRiskD2:
			'トレードビュー Ltd. では、お客様に口座開設していただくことは可能ですが、今回の投資に関して再度お考えいただくことを推奨する必要がございます。お客様の個人情報や投資経験に基づきますと、FX 投資は投資の手段としてリスクが多大過ぎる可能性がございます。FX 投資による損失が、かなりの額になるかもしれません。そのため、お客様の状況や、資金についてご考慮頂いた上で、この投資方法が適切か否か、今一度熟考していただきたく存じます。FX 投資では、高いレバレッジでのお取引が可能となっておりますが、それは小さなマージンの条件が、お客様にとって不利に働くことがあるからです。レバレッジの利用は、大きな損失を生む可能性があると同時に、大きな利益へと導く可能性もございます。',
		additionalRiskChk1:
			'トレードビュー Ltd. によるガイドラインに基づき、私は上記の口座開設条件を満たしていないことを認めます。しかしながら、私の状況における FX 投資の金銭的な危険性について再考した上で、口座の開設を希望いたします。',
		additionalRiskChk2:
			'このボックスにチェックマークを入れることで、上記の全ての情報を読み、理解した上で、同意いたします。',
		additionalRiskChk1Latam:
			'私は自分の取引口座に関連する固有のリスクを認識しており、投資を失った場合のすべての可能な結果を考慮しました。外国為替取引に関連するリスクを読んだ上で、口座開設プロセスを進める意志があります。',
		additionalRiskChk2Latam:
			'このボックスにチェックマークを入れることで、上記の全ての情報を理解し同意をします',
		submitApplicationH: '申請書の提出',
		submitApplicationD1:
			'あと一息です！ここまで申請書をご記入くださいまして感謝申し上げます。申請書を提出するご準備ができましたら、下記の送信ボタンをクリックしてご提出下さい。',
		submitApplicationD2:
			'申請書のご提出完了後、ご登録いただきました法人のメールアドレスにメールを送信いたします。その後、全ての役員様の書類の審査が完了し、認証されましたら、法人口座を開設させて頂きます。',
		submitApplicationD3:
			'ご不明な点や、お手伝いが必要な場合がございましたら、japanesesupport@tvmarkets.com までメールにてご連絡下さい。',
		submitApplicationLink: 'お問い合わせ',
		submitApplicationCheck:
			'私（私たち）は、トレードビューからのメールマガジン購読者リストへの登録に同意いたします。',
		applicationSubmitedH:
			'申請書の提出が完了いたしました。<br> ただ今、審査を行っております。',
		applicationSubmitedD1:
			'この度は弊社に口座申請をいただきありがとうございました。',
		applicationSubmitedD2:
			'ただ今より審査をさせて頂き、口座開設に向けてのお手続きを進めさせていただきます。追加書類のご提出が必要な場合や、書類・情報に不備があった場合は、弊社のオペレーション・チームがご連絡差し上げます。',
		applicationSubmitedD3: '引き続きどうぞよろしくお願いいたします。',
		applicationSubmitedGT: 'マイ・キャビネットへ移動',
		applicationSubmitedET: 'トレードビューについてもっと詳しく知る',
		apEmailL: 'メールアドレス',
		apFirstNL: '名（ローマ字）',
		apFirstNP: '名（ローマ字）',
		apLastNL: '姓（ローマ字）',
		apLastNP: '姓（ローマ字）',
		apDateBL: '生年月日',
		apCountryBL: '出生国',
		apCountryBP: '国を選択',
		apCountryNL: '国籍',
		apCountryNP: '国籍を選択する',
		apMobileL: '携帯電話（オプション）',
		apMobileLReq: '国番号',
		apPhoneL: '電話番号',
		apPassL: 'ID/パスポート番号/SIN',
		apPassP: 'ID、パスポート、SINのいずれかを入力してください。',
		apPassT:
			'身分証明書はいずれか1つだけ入力してください。SIN(社会保険番号)はカナダのユーザーのみ必要ですのでご注意ください。',
		apPassDL: 'ID/パスポート/SINの有効期限',
		apGenderL: '性別',
		apGenderP: 'トレード期間',
		apMaritalL: '配偶者の有無',
		apMaritalP: 'トレード期間',
		apCountryRL: '居住国',
		apCountry: '国',
		apCountryRLTooltip: `これは、あなたのビジネスが主に所在する国を指します。正確な情報を提供していただくことで、地域の要件や規制に基づいてサービスをカスタマイズできます。お住まいの国が選択肢にない場合、申し訳ありませんが、その地域ではサービスを提供できません。`,
		apCountryRLResidence: '居住国',
		apCountryRP: '国を選択',
		apProvinceRL: '都道府県',
		apProvinceRP: '都道府県',
		apCityRL: '市区町村',
		apCityRP: '市区町村を入力してください',
		apStreethRL: '町域・番地',
		apStreethRD: '町域・番地を入力してください',
		apStreethNL: '番地',
		apStreethND: '番地を入力してください',
		apPostCL: '郵便番号',
		apPostCD: '郵便番号を入力してください',
		appAddresT:
			'お住まいの国が選択肢にない場合、申し訳ございませんがサービスをご提供できません。',
		modalCompleteT: '全ての情報登録が完了しました',
		modalCompleteT2: '',
		modalCompleteP:
			'必要書類のご提出が完了しました。最後に代表者様の電子署名をご提出いただき申請書をお送りください。',
		modalRegulationT: '申し訳ございません',
		modalRegulationT2: '',
		modalRegulationP:
			'規制により、米国領土に居住する方へのサービスは提供しておりません。',
		modalRegulationP2: '',
		signatureTM2:
			'ご署名は、既にアップロードされた書類（パスポートなど）に記載されているご署名と同じものである必要がございます。JPG、JPEG、PNG形式で、サイズが 2MB 以下のファイルのみ可。',
		submitModal:
			'入力事項にエラーがございます。必須項目をご確認後再度お試しください。もし改善しない場合は japanesesupport@tvmarkets.com へご連絡をお願いいたします。',
		areaPH: ' 国番号',
		phonePH: '電話番号を半角で入力してください。',
		emailPH: 'メールアドレスを入力してください',
		errorUpload:
			'正しいフォーマットとサイズのファイルをアップロードしてください。',
		apBtnContinue: '次へ',
		apBtnSubmit: '送信',
		apBtnBack: '戻る',
		apBtnRegulation: '規制ページに移動',
		complete: '登録完了',
		pending: '未登録',
		rejected: '拒否',
		accepted: '承認済み',
		enterFirstName: 'お名前をローマ字でご記入ください',
		enterLastName: '姓をローマ字でご記入ください',
		enterAnEmail: 'メールアドレスを入力してくださいl',
		sendInvitation: '招待状を送信',
		invitationSent: 'リクエストが送信されました',
		invitationSentDesc: '口座開設手続きの進度はリアルタイムでご確認が可能です',
		modifiedInvitation: 'セカンダリアカウント所有者情報が正常に更新されました',
		modifiedInvitationDesc:
			'セカンダリ アカウント所有者用に指定したメール アドレスに招待状が送信されました。セカンダリ所有者の追加ページで申請の進行状況を追跡できます。',
		notModifiedInvitation:
			'セカンダリアカウント所有者情報が正常に更新されました',
		notModifiedInvitationDesc:
			'口座開設手続きの進度はリアルタイムでご確認が可能です',
		resend: '再度リクエストを送信する',
		saveShareholder: '保存する',
		shareholderToComplete: '株主に書類提出願いを送る',
		companyDocuments: '法人書類のご提出',
		companyDocumentsDesc: '法人書類から取引口座の安全性と適法性の確認をします',
		documentUpload: '書類のアップロード',
		documentUploadTooltip1:
			'ファイル内の情報と画像が明確で理解しやすいことを確認してください。',
		documentUploadTooltip2:
			'現在お持ちの書類をアップロードしてください。全ての書類がお揃いでない場合もご安心ください。必要書類は後ほどアップロードや送信も可能です。',
		documentUploadDesc:
			'書類を今すぐアップロードされるか、後ほどアップロードされるかを選択してください。今すぐアップロードされる場合は、こちらにファイルをドラッグしていただくか、こちらから選択してください。',
		articlesIncorp: 'Articles of incorporation－履歴事項全部証明書',
		certificateIncorp: 'Certificate of incorporation (発行されている場合)',
		shareholderBreak: 'Shareholder breakdown (発行されている場合)',
		corporateBank: '法人名義の銀行明細書',
		memorandumArticles:
			'Memorandum of association/ Articles of association (発行されている場合)',
		uploadNow: '今すぐアップロードしますか？',
		imageType:
			'JPEG・PNG・PDFのいずれかのファイルで、サイズは３MB以下であることを確認してください。',
		sharesError: '保有株合計がが100％を超えていますので修正をしてください',
		inviteConfirmation: 'リクエストを送信します',
		inviteConfirmationDesc:
			'リクエストの送信後は株主の追加ができませんのでご注意ください',
		inviteSent: 'リクエストが送信されました',
		inviteSentDesc: '株主の追加ページから進歩状況の確認が可能です',
		deleteHolder: '株主情報は削除されます',
		deleteHolderDesc: 'こちらの株主情報を削除してもよろしいですか',
		unableToContinue: '申し訳ございません',
		unableToContinueDesc:
			'ご提供いただいたメールアドレスはすでにTradeviewのアカウントに関連付けられています。続行するには、別のメールアドレスを提供してください。',
		provideAnother: '別のメールアドレスを入力してください',
		duplicated: '重複',
		duplicatedDesc:
			'入力されたメールアドレスはすでにTradeviewのアカウントに関連付けられています。続行するには別のメールアドレスを入力してください。',
	},

	//validations yup app process
	yup: {
		selectOption: '選択してください',
		phone: '電話番号に文字や記号は使用できません。',
		phoneValid: '有効な番号を使用してください',
		dateofBirth: '生年月日を入力してください',
		validEmail: '有効なメールアドレスを入力してください',
		mustBeAdult:
			'有効な生年月日を入力してください。続行するには 18 歳以上である必要があります。',
		passport: '身分証明書番号を入力してください。',
		passportValid: '有効な番号を使用してください',
		passportexpirationdate: '有効期限を入力してください。',
		passportexpirationdateValid: '有効期限をご確認後再度お試しください',
		streetname: '町域・番地を入力してください',
		streetnumber: '番地を入力してください',
		postcode: '番号を入力してください',
		taxReference:
			'税納者番号記入欄にスペースや記号は含まれません。再度ご記入ください。',
		pepstatus: '必要な情報を入力してください。',
		pepstatusValid: '文字数の上限を超えています',
		employer: '雇用主の名前を入力してください',
		occupation: '職業を入力してください',
		employerAddress: '雇用主の住所を入力してください',
		employerpostalcode: '雇用主の郵便番号を入力してください',
		businesstype: '事業の種類を入力してくだBenefit Corporation (B Corp)さい',
		industry: '業界を入力してください',
		business_location: '事業の住所を入力してください',
		business_name: '事業名を入力してくださいe',
		business_website: '事業のウェブサイトURLを入力してください',
		bankruptciesdetails: '詳細をご記入ください',
		acknowledgement: 'ボックスにチェックをし、利用規則に同意してください',
		agree: 'こちらのボックスにチェックマークを入れて同意し、次に進んで下さい。',
		expirationDate: 'パスポートの有効期限が無効です',
		invalidEmail: '正しいフォーマットではありません',
		EmailRequired: 'メールアドレスは必須です',
		companyName: '親会社の名前を入力してください',
		email: '会社のメールアドレスを入力してください',
		businessDescription: '必要な情報を入力してください。',
		required: 'こちらは必須項目です',
		jobTitle: '職名を入力してください',
		emailAlreadyRegistered:
			'メールアドレスが正しくありません。正しく記入してください',
	},

	//helper arrays app proces
	array: {
		usd: 'USD: アメリカドル',
		eur: 'EUR: ユーロ',
		gbp: 'GBP: イギリスポンド',
		female: '女性',
		male: '男性',
		noBinary: 'ノンバイナリー',
		other: 'その他',
		noAnswer: '答えたくない',
		single: '独身',
		married: '既婚',
		divorced: '離婚',
		windowed: '死別',
		registered: '登録パートナーシップ',
		yes: 'はい',
		no: 'いいえ',
		employed: '雇用中',
		selfEmployed: '自営業',
		retired: '退職',
		unemployed: '',
		aerospaceAndDefense: '航空宇宙および防衛',
		agriculture: '農業',
		automotive: '自動車',
		construction: '建設',
		consulting: 'コンサルティング',
		eCommerce: '電子商取引',
		education: '教育',
		energyAndUtilities: 'エネルギーおよび公益事業',
		entertainmentAndMedia: 'エンターテインメントおよびメディア',
		fashionAndApparel: 'ファッションおよびアパレル',
		financeAndBanking: '金融および銀行',
		foodAndBeverage: '食品および飲料',
		government: '政府',
		healthAndWellness: '健康およびウェルネス',
		hospitality: 'ホスピタリティ',
		itTechnology: 'IT/テクノロジー',
		legalServices: '法律サービス',
		manufacturing: '製造',
		marketingAndAdvertising: 'マーケティングおよび広告',
		nonProfitCharity: '非営利/慈善団体',
		realEstate: '不動産',
		retail: '小売',
		benefitCorporation: 'ベネフィット・コーポレーション（B Corp）',
		cooperative: '協同組合',
		cooperativeCorporation: '協同組合法人',
		corporation: '法人',
		familyOwnedBusiness: '家族経営企業',
		franchise: 'フランチャイズ',
		holdingCompany: '持株会社',
		jointVenture: '合弁事業',
		llc: '有限責任会社（LLC）',
		lllp: '有限責任有限パートナーシップ（LLLP）',
		llp: '有限責任パートナーシップ（LLP）',
		lp: '有限パートナーシップ（LP）',
		nonprofitOrganization: '非営利団体',
		partnership: 'パートナーシップ',
		privateEquityFirm: 'プライベート・エクイティ・ファーム',
		professionalCorporation: 'プロフェッショナル・コーポレーション（PC）',
		publiclyTradedCompany: '上場企業',
		sCorporation: 'Sコーポレーション',
		socialEnterprise: 'ソーシャル・エンタープライズ',
		soleProprietorship: '個人事業主',
		serviceProvider: 'サービスプロバイダー',
		telecommunications: '通信',
		transportationAndLogistics: '輸送および物流',
		apprenticeship: '見習い',
		casual: '契約',
		contractual: '一時的',
		freelance: 'フリーランス',
		fullTime: '常勤',
		internship: 'インターンシップ',
		onDemand: 'オンデマンド',
		outsourcedOrOffshore: 'アウトソーシングまたは海外委託',
		partTime: 'パートタイム',
		permanent: '正社員',
		projectBased: 'プロジェクトベース',
		regular: '定期的',
		seasonal: '季節労働',
		temporary: '臨時',
		volunteer: 'ボランティア',
		benefitCorporation: 'ベネフィット・コーポレーション（B Corp）',
		cooperative: '協同組合',
		cooperativeCorporation: '協同組合法人',
		corporation: '法人',
		familyOwnedBusiness: '家族経営企業',
		franchise: 'フランチャイズ',
		holdingCompany: '持株会社',
		jointVenture: '合弁事業',
		limitedLiabilityCompany: '有限責任会社（LLC）',
		limitedLiabilityLimitedPartnership: '有限責任有限パートナーシップ（LLLP）',
		limitedLiabilityPartnership: '有限責任パートナーシップ（LLP）',
		limitedPartnership: '有限パートナーシップ（LP）',
		nonprofitOrganization: '非営利団体',
		partnership: 'パートナーシップ',
		privateEquityFirm: 'プライベート・エクイティ・ファーム',
		professionalCorporation: 'プロフェッショナル・コーポレーション（PC）',
		publiclyTradedCompany: '上場企業',
		sCorporation: 'Sコーポレーション',
		socialEnterprise: 'ソーシャル・エンタープライズ',
		soleProprietorship: '個人事業主',
		below25: '250万円以下',
		between50: '250~500万円',
		between100: '250~500万円',
		over100: '1000万円以上',

		// CORPORATE
		below50mil: '50,000 米ドル未満',
		between100mil: '250~500万円',
		between500mil: '100,000 - 500,000ドル',
		between1000mill: '500,000 米ドルから 1,000,000 米ドルの間',
		over1000mill: '100万ドル以上',
		// END CORPORATE

		savingsFromSalary: '給与からの貯金',
		governmentAid: '国からの支援金',
		sale: '売上',
		investmentsDividends: '投資、配当金',
		incomeFromATrust: '信託からの収入t',
		letting: '不動産収入',
		inheritance: '遺産相続',
		donation: '寄付',
		loan: 'ローン',
		incomeFromSelfEmployment: '自営業による収入',
		parentsPartnerOrOther: '親、配偶者、もしくはその他',
		relativeSupport: '親せきからの援助',
		hedging: 'リスクヘッジ',
		speculation: '投資・投機',
		longTermInvesting: '長期投資',
		proprietaryTrading: '自己勘定取引',
		drawSignature: '署名',
		uploadSignature: '署名のアップロード',
		neverTraded: '経験なし',
		zeroToFiveYears: '0-5年',
		sixToTenYears: '6-10年',
		overTenYears: '10年以上',
		below50K: '50,000ドル未満',
		between50KTo100K: '250~500万円',
		between100KTo500K: '100,000 - 500,000ドル',
		over500K: '500,000ドル以上',
		daily: '毎日',
		weekly: '毎週',
		monthly: '毎月',
		quarterly: '四半期ごと',
		semiAnnually: '半年ごと',
		clientAgreement: '契約書',
		electronicTradingAgreement: '電子版取引契約事項',
		riskDisclosure: 'リスク開示',
		privacyPolicy: 'プライバシーポリシー／個人情報管理方針',
		consentToDelivery: '電子メディアによる取引明細書の送信への同意',
		commissionAgreement: '手数料同意書',
		termsAndConditions: '利用規約',
		swapFreeAccount: 'スワップフリーアカウントの同意書',
		swapFree: 'スワップフリーアカウントの申込書',
		forex: 'Forex',
		stocks: '株式',
		futures: '先物',
		months: {
			january: '１月',
			february: '２月',
			march: '３月',
			april: '４月',
			may: '５月',
			june: '６月',
			july: '７月',
			august: '８月',
			september: '９月',
			october: '１０月',
			november: '１１月',
			december: '１２月',
		},
		passport: 'パスポート',
		identityCard: '在留カード',
		residencePermit: 'マイナンバーカード',
		driversLicense: '運転免許証',
		utilityBill: '公共料金等の請求書',
		bankStatement: '銀行取引明細書',
		certificateResidency: '住民票・印鑑証明',
		today: '今日',
		lastWeek: '先週',
		lastMonth: '先月',
		last3Months: '過去３か月',
		last6Months: '過去６か月',
		costumPeriod: '期間を設定する',
		lastQuarter: '最後の四半期',
		lastSemester: '最後の学期',
		lastYear: '昨年 ',
		step: 'ステップ',
		sell: '売る',
		buy: '買う',
		transfer: '振込',
		deposit: '入金',
		withdrawal: '出金',
		payout: '支払い',
		adjustment: '調整',
		live: 'ライブ',
		demo: 'デモ',
	},
	//MFA
	mfa: {
		body: '口座のセキュリティーのため本人確認方法の追加が可能です',
		text: '2段階認証の設定にはパスワード入力とメールアドレスに送信されるコードが必要です',
		turn: 'Turn',
		on: 'ON',
		off: 'OFF',
		confirm: '決定',
		textTwo: 'MFAを解除してもよろしいですか',
		yes: 'はい',
		no: 'いいえ',
	},

	progress: {
		title: '申請の進行状況',
		progress1: '個人情報',
		progress2: '納税義務',
		progress3: 'プラットフォームと通貨',
		progress31: 'アカウントのセットアップ',
		progress4: '雇用の詳細',
		progress5: '財務内容',
		progress6: '経験',
		progress7: 'IDタイプ',
		progress8: '現住所確認書類',
		progress9: 'レコノシミエント',
		progress91: '同意と提出',
		progress10: '署名',
		progress11: '追加リスク同意書',
		progress12: '申請書の提出',
		progress121: '提出',
		progress13: '第二の口座名義人',
		progress131: '二次ホルダー追加',
	},

	btns_: {
		back: '戻る',
		continue: '次へ',
		cancel: 'キャンセル',
		yesDelete: 'はい、削除します',
		noDelete: 'いや、戻って',
		resendInvitations: '招待状を再送信する',
		yesImSure: 'はい',
		submit: '提出する',
		of: 'の',
	},

	trading_tools: {
		main_title: 'あなたのトレーディングツール',
		main_desc:
			'データに基づいた賢明な意思決定を、マーケットでの優位性を提供する強力なトレーディングツールを使って行いましょう。',
		calculatorSuite: '計算ツールのスイート',
		calculatorSuiteDesc:
			'戦略的な取引に必要なすべてのツールを用意しましょう！この強力なツールキットは、あなたの可能性を引き出し、取引レベルに関係なく力を与えることを目的としています。',
		tradegatehub: 'TradeGATEHub',
		tradegatehubDesc:
			'トレーダーや専門家とのライブチャット、ライブストリーム、リアルタイムのマーケットニュースなど、成長をサポートする無料リソースにアクセスして、自信を持ってマーケットをナビゲートしましょう。',
		surfsup: 'Surf’s Up!',
		surfsupDesc:
			'最新の市場動向を常に把握し、新しい戦略、洞察、分析を探求します。',
	},

	authErrors: {
		default: '予期しないエラーが発生しました。後でもう一度お試しください。',

		register: {
			usernameExists:
				'このメールアドレスは既に登録されています。ログインするか、別のメールアドレスを使用してください。',
			invalidPassword:
				'パスワードは少なくとも8文字で、小文字、大文字、数字、特殊文字を各1つ以上含む必要があります。',
			invalidParameter:
				'いくつかの詳細が正しくないか、欠落しています。情報を確認して、もう一度お試しください。',

			aliasExists:
				'このメールアドレスまたは電話番号は既に別のアカウントに関連付けられています。ログインするか、別のものを使用してください。',
			limitExceeded:
				'認証コードのリクエストが多すぎます。少し待ってから再試行してください。',
			notAuthorized:
				'認証の問題により、サインアップを処理できませんでした。後でもう一度お試しください。',
			codeMismatch: '入力されたコードが無効です。確認して再試行してください。',
		},

		login: {
			userNotFound:
				'入力されたメールアドレスは登録されていません。スペルミスがないか確認するか、新しいアカウントを登録してください。',
			notAuthorized:
				'ログインに失敗しました。資格情報を確認して再試行してください。問題が続く場合は、お問い合わせください。',
			invalidPassword:
				'資格情報が正しくありません。確認して再試行してください。',
			codeMismatch: '入力されたコードが無効です。確認して再試行してください。',
			userNotConfirmed:
				'ログインするにはアカウントを確認してください。確認コードが記載されたメールまたはSMSを確認してください。',
			passwordResetRequired:
				'ログインする前にパスワードをリセットしてください。メールに送信された指示に従ってください。',
			expiredCode:
				'確認コードの有効期限が切れています。新しいコードをリクエストして再試行してください。',
		},

		resetPass: {
			userNotFound:
				'入力されたメールアドレスは登録されていません。スペルミスがないか確認するか、新しいアカウントを登録してください。',
			invalidParameter:
				'必要な情報が正しくないか、欠落しています。情報を確認して再試行してください。',
			notAuthorized:
				'セキュリティパラメータの不足により認証に失敗しました。再試行するか、お問い合わせください。',
			limitExceeded:
				'パスワードリセットの試行が多すぎます。少し待ってから再試行してください。',
			internalError: '問題が発生しました。後でもう一度お試しください。',
			invalidLambda:
				'リクエストを処理できませんでした。後でもう一度お試しください。',
			invalidSmsPolicy:
				'認証用のSMSを送信できませんでした。後でもう一度お試しください。',
			codeMismatch:
				'入力されたコードが正しくありません。確認して再試行してください。',
			expiredCode:
				'入力されたコードの有効期限が切れています。新しいコードをリクエストして再試行してください。',
			invalidPassword:
				'パスワードは少なくとも8文字で、小文字、大文字、数字、特殊文字を各1つ以上含む必要があります。',
		},
	},
}
